export type Maybe<T> = T
export type InputMaybe<T> = T
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never }
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  DateTime: { input: any; output: any }
  JSON: { input: any; output: any }
}

export enum AccountType {
  Custom = 'Custom',
  Express = 'Express',
  Standard = 'Standard',
}

export type AddCampaignDomainInput = {
  campaignId: Scalars['ID']['input']
  campaignSlug: Scalars['ID']['input']
}

export type AddCampaignMatchedGivingSettingResult = {
  __typename?: 'AddCampaignMatchedGivingSettingResult'
  id: Scalars['String']['output']
}

export type AddMergeFieldInput = {
  description?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
}

export type AddPageBucketSlugsForCampaignInput = {
  campaignId: Scalars['ID']['input']
  slugs: Array<PageBucketSlugsDetailsInput>
}

export type AddPageSlugsForCampaignInput = {
  campaignId: Scalars['ID']['input']
  slugs: Array<PageSlugsDetailsInput>
}

export type AddPayPalByReferralInput = {
  merchantEmail: Scalars['String']['input']
  merchantId: Scalars['String']['input']
  mode: Mode
}

export type AddressInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>
  addressLine2?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  postcode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
}

export type AggregatedGiving = {
  __typename?: 'AggregatedGiving'
  amount: Scalars['Float']['output']
  date: Scalars['DateTime']['output']
}

export type AggregatedGivings = {
  __typename?: 'AggregatedGivings'
  amounts: Array<AggregatedGiving>
  total?: Maybe<Scalars['Float']['output']>
}

export type AggregatedGivingsInput = {
  end: Scalars['DateTime']['input']
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  start: Scalars['DateTime']['input']
  timezoneOffsetInMinutes: Scalars['Int']['input']
}

export type AggregationSetting = {
  groupSettings?: Maybe<Array<AggregationSettingItem>>
  isAllPagesLinked?: Maybe<Scalars['Boolean']['output']>
}

export type AggregationSettingItem = {
  dataSources?: Maybe<Array<Scalars['ID']['output']>>
  groupId: Scalars['ID']['output']
  groupName?: Maybe<Scalars['String']['output']>
  isAllPagesLinked?: Maybe<Scalars['Boolean']['output']>
  pageBucketIds?: Maybe<Array<Scalars['ID']['output']>>
  pageIds: Array<Scalars['ID']['output']>
}

export enum AggregationSettingType {
  All = 'All',
  Individual = 'Individual',
  Selected = 'Selected',
}

export type AggregationSettings = {
  __typename?: 'AggregationSettings'
  commentSetting?: Maybe<CommentAggregationSetting>
  countdownTimerSetting?: Maybe<CountdownTimerAggregationSetting>
  matchedGivingSetting?: Maybe<MatchedGivingAggregationSetting>
  progressBarSetting?: Maybe<ProgressBarAggregationSetting>
}

export type AmountTrigger = {
  __typename?: 'AmountTrigger'
  amountStart: Scalars['Float']['output']
  pageId: Scalars['ID']['output']
}

export type AmountTriggerInput = {
  amountStart: Scalars['Float']['input']
  pageId: Scalars['ID']['input']
}

export enum AnalyticsDeviceType {
  Desktop = 'Desktop',
  Mobile = 'Mobile',
  Tablet = 'Tablet',
}

export type AnalyticsInput = {
  campaignId?: InputMaybe<Scalars['String']['input']>
  charityId?: InputMaybe<Scalars['String']['input']>
  deviceType?: InputMaybe<AnalyticsDeviceType>
  deviceUUID?: InputMaybe<Scalars['String']['input']>
  donationPageUrl?: InputMaybe<Scalars['String']['input']>
  eventId?: InputMaybe<Scalars['String']['input']>
  fbc?: InputMaybe<Scalars['String']['input']>
  fbp?: InputMaybe<Scalars['String']['input']>
  hasFbPixel?: InputMaybe<Scalars['Boolean']['input']>
  hasGoogleAnalytics?: InputMaybe<Scalars['Boolean']['input']>
  isConversionsApi?: InputMaybe<Scalars['Boolean']['input']>
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  isLocalStorageAllowed?: InputMaybe<Scalars['Boolean']['input']>
  pageId?: InputMaybe<Scalars['String']['input']>
  pixelId?: InputMaybe<Scalars['String']['input']>
  userAgent?: InputMaybe<Scalars['String']['input']>
}

export type AnalyticsIntegrationSettings = {
  __typename?: 'AnalyticsIntegrationSettings'
  ga4Settings: Array<Ga4IntegrationSetting>
  gtmSettings: Array<GtmIntegrationSetting>
  identityPartnerSettings?: Maybe<IdentityPartnerSetting>
  pixelConversionsApiSettings: Array<PixelConversionsApiIntegrationSetting>
  raiserEdgeIntegrationSettings?: Maybe<Array<RaiserEdgeIntegrationSetting>>
}

export enum AnalyticsType {
  Ga4 = 'Ga4',
  Gtm = 'Gtm',
  PixelConversionsApi = 'PixelConversionsApi',
}

export type ApiDonationCampaignAnalyticsSettings = {
  __typename?: 'ApiDonationCampaignAnalyticsSettings'
  ga4Analytic?: Maybe<ApiDonationGa4Setting>
  googleAnalytic?: Maybe<ApiDonationGtmSetting>
  metaPixelAnalytic?: Maybe<ApiDonationMetaPixelAnalyticSetting>
}

export type ApiDonationCampaignSettings = {
  __typename?: 'ApiDonationCampaignSettings'
  aggregationSettings?: Maybe<AggregationSettings>
  analyticSettings?: Maybe<ApiDonationCampaignAnalyticsSettings>
  isPeerToPeerGivingNotificationEnabled?: Maybe<Scalars['Boolean']['output']>
  matchedGivingSettings?: Maybe<Array<CampaignMatchedGivingSetting>>
  pageReferences: Array<PageReference>
}

export type ApiDonationCharityPageRedirectionSettings = {
  __typename?: 'ApiDonationCharityPageRedirectionSettings'
  from: Scalars['String']['output']
  to?: Maybe<Scalars['String']['output']>
  type: PageRedirectType
}

export type ApiDonationCharitySettings = {
  __typename?: 'ApiDonationCharitySettings'
  redirectUrl?: Maybe<Scalars['String']['output']>
}

export type ApiDonationGtmSetting = {
  __typename?: 'ApiDonationGTMSetting'
  googleTagId?: Maybe<Scalars['ID']['output']>
  isEnabled?: Maybe<Scalars['Boolean']['output']>
}

export type ApiDonationGa4Setting = {
  __typename?: 'ApiDonationGa4Setting'
  ga4MeasurementId?: Maybe<Scalars['ID']['output']>
  isEnabled?: Maybe<Scalars['Boolean']['output']>
}

export type ApiDonationMetaPixelAnalyticSetting = {
  __typename?: 'ApiDonationMetaPixelAnalyticSetting'
  isConversionsAPI?: Maybe<Scalars['Boolean']['output']>
  metaPixelId?: Maybe<Scalars['ID']['output']>
}

export type Appeal = {
  __typename?: 'Appeal'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  rows: Array<Maybe<Row>>
}

export type ApplicationFeeRefundTransactionDetail = {
  __typename?: 'ApplicationFeeRefundTransactionDetail'
  applicationFeeAmount: Scalars['Float']['output']
}

export enum AssetCategoryType {
  Document = 'Document',
  Image = 'Image',
}

export type AuthenticateProfileResponse = {
  __typename?: 'AuthenticateProfileResponse'
  profileUrl: Scalars['String']['output']
  token: Scalars['String']['output']
}

export type Balance = {
  __typename?: 'Balance'
  count: Scalars['Int']['output']
  totalAmount: Scalars['Float']['output']
}

export type BaseCampaignSettings = {
  __typename?: 'BaseCampaignSettings'
  endDateTime?: Maybe<Scalars['String']['output']>
  goal?: Maybe<Scalars['Float']['output']>
  startDateTime?: Maybe<Scalars['String']['output']>
}

export type BonusGoal = {
  __typename?: 'BonusGoal'
  customTickColor?: Maybe<Scalars['String']['output']>
  customTickUrl?: Maybe<Scalars['String']['output']>
  index: Scalars['Int']['output']
  isTickHidden?: Maybe<Scalars['Boolean']['output']>
  showPastGoals?: Maybe<Scalars['Boolean']['output']>
  text?: Maybe<Text>
}

export type BonusGoalInput = {
  customTickColor?: InputMaybe<Scalars['String']['input']>
  customTickUrl?: InputMaybe<Scalars['String']['input']>
  index: Scalars['Int']['input']
  isTickHidden?: InputMaybe<Scalars['Boolean']['input']>
  showPastGoals?: InputMaybe<Scalars['Boolean']['input']>
  text?: InputMaybe<TextInput>
}

export type Branding = {
  __typename?: 'Branding'
  id: Scalars['ID']['output']
  isDefault: Scalars['Boolean']['output']
  logoStyle?: Maybe<Scalars['String']['output']>
  logoURL?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type Button = Component & {
  __typename?: 'Button'
  buttonText: Scalars['String']['output']
  buttonType: Scalars['String']['output']
  html?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  target?: Maybe<Scalars['String']['output']>
  type: ComponentType
  url?: Maybe<Scalars['String']['output']>
}

export type ButtonInput = {
  buttonType: Scalars['String']['input']
  componentId: Scalars['ID']['input']
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  target?: InputMaybe<Scalars['String']['input']>
  text: Scalars['String']['input']
  type: ComponentTypeInput
  url?: InputMaybe<Scalars['String']['input']>
}

export type CamaignGa4Setting = {
  __typename?: 'CamaignGa4Setting'
  ga4SettingId?: Maybe<Scalars['ID']['output']>
  isDisabled?: Maybe<Scalars['Boolean']['output']>
}

export type CamaignGtmSetting = {
  __typename?: 'CamaignGtmSetting'
  gtmSettingId?: Maybe<Scalars['ID']['output']>
  isDisabled?: Maybe<Scalars['Boolean']['output']>
}

export type Campaign = {
  __typename?: 'Campaign'
  buckets?: Maybe<Array<PageBucketDetail>>
  campaignDomain?: Maybe<Scalars['String']['output']>
  endDate?: Maybe<Scalars['String']['output']>
  goal?: Maybe<Scalars['Float']['output']>
  id: Scalars['ID']['output']
  isP2PEnabled: Scalars['Boolean']['output']
  pages?: Maybe<Array<PageDetail>>
  platformFeeType?: Maybe<PlatformFeeType>
  startDate?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
  type?: Maybe<CampaignType>
}

export type CampaignAnalyticsSettings = {
  __typename?: 'CampaignAnalyticsSettings'
  ga4?: Maybe<CamaignGa4Setting>
  gtm?: Maybe<CamaignGtmSetting>
  pixelConversionsApi?: Maybe<CampaignPixelSetting>
}

export type CampaignAnalyticsSettingsInput = {
  campaignId: Scalars['ID']['input']
  ga4?: InputMaybe<CampaignGa4SettingInput>
  gtm?: InputMaybe<CampaignGtmSettingInput>
  pixelConversionsApi?: InputMaybe<CampaignPixelSettingInput>
}

export type CampaignAsset = {
  __typename?: 'CampaignAsset'
  categoryType: AssetCategoryType
  fileName: Scalars['String']['output']
  id: Scalars['ID']['output']
  url: Scalars['String']['output']
}

export type CampaignDomain = {
  __typename?: 'CampaignDomain'
  domain: Scalars['String']['output']
  origin: Scalars['String']['output']
  slug?: Maybe<Scalars['String']['output']>
}

export type CampaignDonationByDateStat = {
  __typename?: 'CampaignDonationByDateStat'
  date: Scalars['String']['output']
  donationAmount: Scalars['Float']['output']
  donationCount: Scalars['Int']['output']
}

export type CampaignDonorAmountStat = {
  __typename?: 'CampaignDonorAmountStat'
  amount: Scalars['Float']['output']
  donorName: Scalars['String']['output']
}

export type CampaignGa4SettingInput = {
  ga4SettingId?: InputMaybe<Scalars['ID']['input']>
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>
}

export type CampaignGtmSettingInput = {
  gtmSettingId?: InputMaybe<Scalars['ID']['input']>
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>
}

export type CampaignMatchedGivingSetting = {
  __typename?: 'CampaignMatchedGivingSetting'
  endAt?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  name: Scalars['String']['output']
  rounds: Array<CampaignMatchedGivingSettingItem>
  startAt: Scalars['String']['output']
}

export type CampaignMatchedGivingSettingInput = {
  campaignId: Scalars['String']['input']
  endAt?: InputMaybe<Scalars['String']['input']>
  matchedGivingSettingId?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  rounds: Array<CampaignMatchedGivingSettingItemInput>
  startAt: Scalars['String']['input']
}

export type CampaignMatchedGivingSettingItem = {
  __typename?: 'CampaignMatchedGivingSettingItem'
  endFundRange: Scalars['Float']['output']
  multiplier: Scalars['Float']['output']
  startFundRange: Scalars['Float']['output']
}

export type CampaignMatchedGivingSettingItemInput = {
  endFundRange: Scalars['Float']['input']
  multiplier: Scalars['Float']['input']
  startFundRange: Scalars['Float']['input']
}

export type CampaignMetadata = {
  __typename?: 'CampaignMetadata'
  CampaignGoal?: Maybe<Scalars['String']['output']>
  CampaignName?: Maybe<Scalars['String']['output']>
  fbPixelId?: Maybe<Scalars['String']['output']>
  ga4ScriptId?: Maybe<Scalars['String']['output']>
  gtmScriptId?: Maybe<Scalars['String']['output']>
  isConversionsApi?: Maybe<Scalars['Boolean']['output']>
  ogImage?: Maybe<Scalars['String']['output']>
  ogTitle?: Maybe<Scalars['String']['output']>
}

export type CampaignOverview = {
  __typename?: 'CampaignOverview'
  buckets?: Maybe<Array<PageBucketDetail>>
  campaignSettings?: Maybe<CampaignSettings>
  id: Scalars['ID']['output']
  pages?: Maybe<Array<PageDetail>>
  totalAmount: Scalars['Float']['output']
  totalDonors: Scalars['Int']['output']
}

export type CampaignPageDonationAmountStat = {
  __typename?: 'CampaignPageDonationAmountStat'
  amount: Scalars['Float']['output']
  count: Scalars['Int']['output']
  pageName: Scalars['String']['output']
}

export type CampaignPaymentSettings = {
  __typename?: 'CampaignPaymentSettings'
  paypal?: Maybe<CharityPayPalSettings>
  platformFeeType?: Maybe<PlatformFeeType>
  stripe?: Maybe<CharityStripeSettings>
}

export type CampaignPixelSetting = {
  __typename?: 'CampaignPixelSetting'
  isDisabled?: Maybe<Scalars['Boolean']['output']>
  pixelSettingId?: Maybe<Scalars['ID']['output']>
}

export type CampaignPixelSettingInput = {
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>
  pixelSettingId?: InputMaybe<Scalars['ID']['input']>
}

export type CampaignSettings = {
  __typename?: 'CampaignSettings'
  aggregationSettings?: Maybe<AggregationSettings>
  analyticsSettings?: Maybe<CampaignAnalyticsSettings>
  baseSettings?: Maybe<BaseCampaignSettings>
  campaignDomain?: Maybe<Scalars['String']['output']>
  defaultCampaignPageId?: Maybe<Scalars['ID']['output']>
  emailReceiptSettings?: Maybe<EmailReceiptSettings>
  isPeerToPeerGivingNotificationEnabled?: Maybe<Scalars['Boolean']['output']>
  matchedGivingSettings?: Maybe<Array<CampaignMatchedGivingSetting>>
  pageReferences?: Maybe<Array<PageReference>>
  paymentSettings?: Maybe<PreviewCampaignPaymentSettings>
  peerToPeerPageMapSettings?: Maybe<PeerToPeerPageMapSettings>
}

export type CampaignTrigger = {
  __typename?: 'CampaignTrigger'
  campaignTriggerId?: Maybe<Scalars['ID']['output']>
  dateTimeTriggers: Array<DateTimeTrigger>
}

export type CampaignTriggerInput = {
  campaignId: Scalars['ID']['input']
  campaignTriggerId?: InputMaybe<Scalars['ID']['input']>
  dateTimeTriggers: Array<DateTimeTriggerInput>
  pageBucketId: Scalars['ID']['input']
}

export enum CampaignType {
  Appeal = 'Appeal',
  GivingDay = 'GivingDay',
  P2P = 'P2P',
  VirtualGift = 'VirtualGift',
}

export type CampaignUtmTagDonationAmountStat = {
  __typename?: 'CampaignUtmTagDonationAmountStat'
  amount: Scalars['Float']['output']
  count: Scalars['Int']['output']
  tagName: Scalars['String']['output']
  tagValue: Scalars['String']['output']
}

export type CancelSubscriptionInput = {
  externalSubscriptionId: Scalars['String']['input']
  paymentSubscriptionId: Scalars['ID']['input']
}

export type Charity = {
  __typename?: 'Charity'
  description: Scalars['String']['output']
  id: Scalars['ID']['output']
  isActive: Scalars['Boolean']['output']
  logo: Scalars['String']['output']
  name: Scalars['String']['output']
  url?: Maybe<Scalars['String']['output']>
}

export type CharityAsset = {
  __typename?: 'CharityAsset'
  categoryType: AssetCategoryType
  fileName: Scalars['String']['output']
  id: Scalars['ID']['output']
  url: Scalars['String']['output']
}

export type CharityClaim = {
  __typename?: 'CharityClaim'
  id: Scalars['ID']['output']
  logoUrl?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
}

export type CharityDetail = {
  __typename?: 'CharityDetail'
  abn?: Maybe<Scalars['String']['output']>
  autoSendTaxSummaryEmailDate?: Maybe<Scalars['String']['output']>
  branding?: Maybe<Scalars['ID']['output']>
  description?: Maybe<Scalars['String']['output']>
  domain?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  faviconUrl?: Maybe<Scalars['String']['output']>
  fromEmail?: Maybe<Scalars['String']['output']>
  fromName?: Maybe<Scalars['String']['output']>
  isDgrEndorsed?: Maybe<Scalars['Boolean']['output']>
  logoUrl?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  reversedLogoUrl?: Maybe<Scalars['String']['output']>
  sendPdfReceipt?: Maybe<Scalars['Boolean']['output']>
}

export type CharityDetailInput = {
  abn: Scalars['String']['input']
  autoSendTaxSummaryEmailDate?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  faviconUrl?: InputMaybe<Scalars['String']['input']>
  isDgrEndorsed: Scalars['Boolean']['input']
  logoUrl?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  phone?: InputMaybe<Scalars['String']['input']>
  reversedLogoUrl?: InputMaybe<Scalars['String']['input']>
  sendPdfReceipt: Scalars['Boolean']['input']
}

export type CharityDonorPortalPermissionsInput = {
  regularGivingPermissions?: InputMaybe<CharityDonorPortalRegularGivingPermissionsInput>
}

export type CharityDonorPortalRegularGivingPermissions = {
  __typename?: 'CharityDonorPortalRegularGivingPermissions'
  canCancelDonation: Scalars['Boolean']['output']
  canEditAmount: Scalars['Boolean']['output']
  canEditDonationEndDate: Scalars['Boolean']['output']
  canEditFrequency: Scalars['Boolean']['output']
  canEditName: Scalars['Boolean']['output']
  canEditNextPaymentDate: Scalars['Boolean']['output']
  canPauseDonation: Scalars['Boolean']['output']
  canResumeDonation: Scalars['Boolean']['output']
  updatePaymentDetails: UpdatePaymentMethodPermission
}

export type CharityDonorPortalRegularGivingPermissionsInput = {
  canCancelDonation: Scalars['Boolean']['input']
  canEditAmount: Scalars['Boolean']['input']
  canEditDonationEndDate: Scalars['Boolean']['input']
  canEditFrequency: Scalars['Boolean']['input']
  canEditName: Scalars['Boolean']['input']
  canEditNextPaymentDate: Scalars['Boolean']['input']
  canPauseDonation: Scalars['Boolean']['input']
  canResumeDonation: Scalars['Boolean']['input']
  updatePaymentDetails: UpdatePaymentMethodPermission
}

export type CharityDonorPortalSettings = {
  __typename?: 'CharityDonorPortalSettings'
  branding?: Maybe<Scalars['ID']['output']>
  domain?: Maybe<Scalars['String']['output']>
  regularGivingPermissions?: Maybe<CharityDonorPortalRegularGivingPermissions>
}

export type CharityMetadata = {
  __typename?: 'CharityMetadata'
  ABN?: Maybe<Scalars['String']['output']>
  CharityName?: Maybe<Scalars['String']['output']>
  CustomFields?: Maybe<Scalars['String']['output']>
  Email?: Maybe<Scalars['String']['output']>
  FaviconUrl?: Maybe<Scalars['String']['output']>
  LogoUrl?: Maybe<Scalars['String']['output']>
  Phone?: Maybe<Scalars['String']['output']>
  ReversedLogoUrl?: Maybe<Scalars['String']['output']>
}

export type CharityOfflineSettings = {
  __typename?: 'CharityOfflineSettings'
  accountId: Scalars['String']['output']
  id: Scalars['ID']['output']
  label?: Maybe<Scalars['String']['output']>
  providerType?: Maybe<PaymentProviderType>
}

export type CharityPageRedirectionSetting = {
  __typename?: 'CharityPageRedirectionSetting'
  externalTo?: Maybe<Scalars['String']['output']>
  from: Array<CharityPageRedirectionSettingItem>
  id: Scalars['ID']['output']
  to?: Maybe<CharityPageRedirectionSettingItem>
}

export type CharityPageRedirectionSettingItem = {
  __typename?: 'CharityPageRedirectionSettingItem'
  campaignId: Scalars['ID']['output']
  campaignName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  type: PageRedirectType
}

export type CharityPageRedirectionSettingItemInput = {
  id: Scalars['ID']['input']
  type: PageRedirectType
}

export type CharityPageRedirectionSettingsInput = {
  externalTo?: InputMaybe<Scalars['String']['input']>
  from: Array<CharityPageRedirectionSettingItemInput>
  id: Scalars['ID']['input']
  to?: InputMaybe<CharityPageRedirectionSettingItemInput>
}

export type CharityPayPalSettings = {
  __typename?: 'CharityPayPalSettings'
  id: Scalars['ID']['output']
  isDefault?: Maybe<Scalars['Boolean']['output']>
  label?: Maybe<Scalars['String']['output']>
  merchantEmail?: Maybe<Scalars['String']['output']>
  providerType?: Maybe<PaymentProviderType>
}

export type CharityPayPalSettingsInput = {
  label: Scalars['String']['input']
  merchantEmail: Scalars['String']['input']
  merchantId: Scalars['ID']['input']
}

export type CharityPaymentSettings = {
  __typename?: 'CharityPaymentSettings'
  offline?: Maybe<Array<CharityOfflineSettings>>
  payPal?: Maybe<Array<CharityPayPalSettings>>
  platformFeeType?: Maybe<PlatformFeeType>
  stripe?: Maybe<Array<CharityStripeSettings>>
}

export type CharityStripeSettings = {
  __typename?: 'CharityStripeSettings'
  accountId: Scalars['String']['output']
  id: Scalars['ID']['output']
  isDefault?: Maybe<Scalars['Boolean']['output']>
  label?: Maybe<Scalars['String']['output']>
  providerType?: Maybe<PaymentProviderType>
}

export type CharityStripeSettingsInput = {
  accountId: Scalars['String']['input']
  label: Scalars['String']['input']
}

export enum CharityTaxSummaryMessageType {
  Everyone = 'Everyone',
  RegularGivingsOnly = 'RegularGivingsOnly',
}

export enum CharityTaxSummarySendLogStatus {
  Completed = 'Completed',
  Failed = 'Failed',
  Initiated = 'Initiated',
  Processing = 'Processing',
}

export type CharityTaxSummaryStatus = {
  __typename?: 'CharityTaxSummaryStatus'
  isSendLogExists: Scalars['Boolean']['output']
  status?: Maybe<CharityTaxSummarySendLogStatus>
  totalEmailCount?: Maybe<Scalars['Int']['output']>
}

export type CharityTemplateDetail = {
  __typename?: 'CharityTemplateDetail'
  id: Scalars['ID']['output']
  layout?: Maybe<Page>
  name?: Maybe<Scalars['String']['output']>
  screenshotImageUrl?: Maybe<Scalars['String']['output']>
}

export enum CharityTemplateType {
  Page = 'Page',
  Section = 'Section',
}

export type CharityUser = {
  __typename?: 'CharityUser'
  email: Scalars['String']['output']
  name?: Maybe<Scalars['String']['output']>
  role?: Maybe<Role>
  userId: Scalars['ID']['output']
}

export type CharityUserWithPagination = {
  __typename?: 'CharityUserWithPagination'
  items: Array<CharityUser>
  totalRecords: Scalars['Int']['output']
}

export type Color = {
  __typename?: 'Color'
  hex: Scalars['String']['output']
  rgb: RgbColor
}

export type ColorInput = {
  hex: Scalars['String']['input']
  rgb: RgbColorInput
}

export type Column = Component & {
  __typename?: 'Column'
  components: Array<PageComponent>
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type ColumnInput = {
  componentId: Scalars['ID']['input']
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  type: ComponentTypeInput
}

export type Comment = {
  __typename?: 'Comment'
  amount: Scalars['Float']['output']
  dedicateeName?: Maybe<Scalars['String']['output']>
  donatedAt: Scalars['DateTime']['output']
  donatedBy: Scalars['String']['output']
  donatedTo?: Maybe<DonatedTo>
  id: Scalars['ID']['output']
  matchedAmount?: Maybe<Scalars['Float']['output']>
  matchedDonationAmount?: Maybe<Scalars['Float']['output']>
  message?: Maybe<Scalars['String']['output']>
  organisationName?: Maybe<Scalars['String']['output']>
}

export type CommentAggregationSetting = AggregationSetting & {
  __typename?: 'CommentAggregationSetting'
  groupSettings?: Maybe<Array<CommentAggregationSettingItem>>
  isAllPagesLinked?: Maybe<Scalars['Boolean']['output']>
}

export type CommentAggregationSettingItem = AggregationSettingItem & {
  __typename?: 'CommentAggregationSettingItem'
  amountToShowOver?: Maybe<Scalars['Float']['output']>
  dataSources?: Maybe<Array<Scalars['ID']['output']>>
  endVisibleTime?: Maybe<Scalars['DateTime']['output']>
  groupId: Scalars['ID']['output']
  groupName?: Maybe<Scalars['String']['output']>
  isAllPagesLinked?: Maybe<Scalars['Boolean']['output']>
  pageBucketIds?: Maybe<Array<Scalars['ID']['output']>>
  pageIds: Array<Scalars['ID']['output']>
  startVisibleTime?: Maybe<Scalars['DateTime']['output']>
}

export type CommentAggregationSettingItemInput = {
  amountToShowOver?: InputMaybe<Scalars['Float']['input']>
  dataSources?: InputMaybe<Array<Scalars['ID']['input']>>
  endVisibleTime?: InputMaybe<Scalars['DateTime']['input']>
  groupId: Scalars['ID']['input']
  groupName?: InputMaybe<Scalars['String']['input']>
  isAllPagesLinked?: InputMaybe<Scalars['Boolean']['input']>
  pageBucketIds?: InputMaybe<Array<Scalars['ID']['input']>>
  pageIds: Array<Scalars['ID']['input']>
  startVisibleTime?: InputMaybe<Scalars['DateTime']['input']>
}

export type CommentInput = {
  charityId: Scalars['ID']['input']
  dedicateeEmail?: InputMaybe<Scalars['String']['input']>
  dedicateeName?: InputMaybe<Scalars['String']['input']>
  fullName: Scalars['String']['input']
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  isPIIPublic: Scalars['Boolean']['input']
  message?: InputMaybe<Scalars['String']['input']>
  organisationName?: InputMaybe<Scalars['String']['input']>
  paymentSubscriptionId?: InputMaybe<Scalars['ID']['input']>
  paymentTransactionId?: InputMaybe<Scalars['ID']['input']>
  profileId?: InputMaybe<Scalars['ID']['input']>
}

export type Comments = Component & {
  __typename?: 'Comments'
  amountToShowOver?: Maybe<Scalars['Int']['output']>
  end?: Maybe<Scalars['DateTime']['output']>
  hideBeforeStart?: Maybe<Scalars['Boolean']['output']>
  hideOnEnd?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  isAllPagesLinked?: Maybe<Scalars['Boolean']['output']>
  layout: CommentsLayout
  linkedPageIds?: Maybe<Array<Scalars['ID']['output']>>
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  showAmount: Scalars['Boolean']['output']
  showMessage: Scalars['Boolean']['output']
  showTotal: Scalars['Boolean']['output']
  showViewAll: Scalars['Boolean']['output']
  start?: Maybe<Scalars['DateTime']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type CommentsInput = {
  amountToShowOver?: InputMaybe<Scalars['Int']['input']>
  componentId: Scalars['ID']['input']
  end?: InputMaybe<Scalars['DateTime']['input']>
  hideBeforeStart?: InputMaybe<Scalars['Boolean']['input']>
  hideOnEnd?: InputMaybe<Scalars['Boolean']['input']>
  isAllPagesLinked?: InputMaybe<Scalars['Boolean']['input']>
  layout: CommentsLayout
  linkedPageIds?: InputMaybe<Array<Scalars['ID']['input']>>
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  showAmount: Scalars['Boolean']['input']
  showMessage: Scalars['Boolean']['input']
  showTotal: Scalars['Boolean']['input']
  showViewAll: Scalars['Boolean']['input']
  start?: InputMaybe<Scalars['DateTime']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  type: ComponentTypeInput
}

export enum CommentsLayout {
  Horizontal = 'HORIZONTAL',
  Vertical = 'VERTICAL',
}

export type CommentsQueryInput = {
  campaignId: Scalars['ID']['input']
  charityId: Scalars['ID']['input']
  hasFundraiserSupported?: InputMaybe<Scalars['Boolean']['input']>
  includeMatchedAmount?: InputMaybe<Scalars['Boolean']['input']>
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  onlyDedicatedComments?: InputMaybe<Scalars['Boolean']['input']>
  pageId?: InputMaybe<Scalars['ID']['input']>
  pageIds?: InputMaybe<Array<Scalars['ID']['input']>>
  pagination?: InputMaybe<PaginationQuery>
  profileId?: InputMaybe<Scalars['ID']['input']>
}

export type CommentsQueryResult = {
  __typename?: 'CommentsQueryResult'
  comments: Array<Comment>
  totalRecords: Scalars['Int']['output']
}

export type Component = {
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export enum ComponentDirection {
  BottomToTop = 'BottomToTop',
  LeftToRight = 'LeftToRight',
  RightToLeft = 'RightToLeft',
  TopToBottom = 'TopToBottom',
}

export enum ComponentType {
  Button = 'Button',
  Column = 'Column',
  Comments = 'Comments',
  CountdownTimer = 'CountdownTimer',
  DollarHandles = 'DollarHandles',
  DonationForm = 'DonationForm',
  Empty = 'Empty',
  Footer = 'Footer',
  FundraiserButton = 'FundraiserButton',
  FundraiserProfile = 'FundraiserProfile',
  Header = 'Header',
  Image = 'Image',
  Leaderboard = 'Leaderboard',
  LoginForm = 'LoginForm',
  PageOptions = 'PageOptions',
  PostDonationForm = 'PostDonationForm',
  ProgressBar = 'ProgressBar',
  ProgressImage = 'ProgressImage',
  RegisterForm = 'RegisterForm',
  Row = 'Row',
  SocialShare = 'SocialShare',
  Text = 'Text',
  Video = 'Video',
  VirtualGiftAmountSelector = 'VirtualGiftAmountSelector',
  VirtualGiftItemDownload = 'VirtualGiftItemDownload',
  VirtualGiftPaymentForm = 'VirtualGiftPaymentForm',
  VirtualGiftPersonalisation = 'VirtualGiftPersonalisation',
  VirtualGiftPreviewImage = 'VirtualGiftPreviewImage',
  VirtualGiftSection = 'VirtualGiftSection',
}

export enum ComponentTypeInput {
  ButtonElement = 'ButtonElement',
  ColumnElement = 'ColumnElement',
  CommentsElement = 'CommentsElement',
  CountdownTimerElement = 'CountdownTimerElement',
  CustomFieldElement = 'CustomFieldElement',
  DollarHandlesElement = 'DollarHandlesElement',
  DonationFormElement = 'DonationFormElement',
  EmptyElement = 'EmptyElement',
  FooterElement = 'FooterElement',
  FundraiserButtonElement = 'FundraiserButtonElement',
  FundraiserProfileElement = 'FundraiserProfileElement',
  HeaderElement = 'HeaderElement',
  ImageElement = 'ImageElement',
  LeaderboardElement = 'LeaderboardElement',
  LoginFormElement = 'LoginFormElement',
  PageOptionsElement = 'PageOptionsElement',
  PostDonationFormElement = 'PostDonationFormElement',
  ProgressBarElement = 'ProgressBarElement',
  ProgressImageElement = 'ProgressImageElement',
  RegisterFormElement = 'RegisterFormElement',
  RowElement = 'RowElement',
  SocialShareElement = 'SocialShareElement',
  TextElement = 'TextElement',
  VideoElement = 'VideoElement',
  VirtualGiftSectionElement = 'VirtualGiftSectionElement',
}

export type ComponentsInput = {
  buttonElements?: InputMaybe<Array<ButtonInput>>
  columnElements?: InputMaybe<Array<ColumnInput>>
  commentsElements?: InputMaybe<Array<CommentsInput>>
  countdownTimerElements?: InputMaybe<Array<CountdownTimerInput>>
  customFieldElements?: InputMaybe<Array<CustomFieldElementInput>>
  dollarHandlesElements?: InputMaybe<Array<DollarHandlesInput>>
  donationFormElements?: InputMaybe<Array<DonationFormInput>>
  fundraiserButtonElements?: InputMaybe<Array<FundraiserButtonInput>>
  fundraiserProfileElements?: InputMaybe<Array<FundraiserProfileInput>>
  imageElements?: InputMaybe<Array<ImageInput>>
  leaderboardElements?: InputMaybe<Array<LeaderboardInput>>
  loginFormElements?: InputMaybe<Array<LoginFormInput>>
  pageOptionsElements?: InputMaybe<Array<PageOptionsInput>>
  postDonationFormElements?: InputMaybe<Array<PostDonationFormInput>>
  progressBarElements?: InputMaybe<Array<ProgressBarInput>>
  progressImageElements?: InputMaybe<Array<ProgressImageInput>>
  registerFormElements?: InputMaybe<Array<RegisterFormInput>>
  rowElements?: InputMaybe<Array<RowInput>>
  socialShareElements?: InputMaybe<Array<SocialShareInput>>
  textElements?: InputMaybe<Array<TextInput>>
  videoElements?: InputMaybe<Array<VideoInput>>
  virtualGiftSectionElements?: InputMaybe<Array<VirtualGiftSectionInput>>
}

export type CountdownTimer = Component & {
  __typename?: 'CountdownTimer'
  bonusFinishTimes?: Maybe<Array<Scalars['DateTime']['output']>>
  end?: Maybe<Scalars['DateTime']['output']>
  finish?: Maybe<Scalars['DateTime']['output']>
  hideBeforeStart?: Maybe<Scalars['Boolean']['output']>
  hideOnEnd?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  start?: Maybe<Scalars['DateTime']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type CountdownTimerAggregationSetting = AggregationSetting & {
  __typename?: 'CountdownTimerAggregationSetting'
  groupSettings?: Maybe<Array<CountdownTimerAggregationSettingItem>>
  isAllPagesLinked?: Maybe<Scalars['Boolean']['output']>
}

export type CountdownTimerAggregationSettingItem = AggregationSettingItem & {
  __typename?: 'CountdownTimerAggregationSettingItem'
  bonusFinishTimes?: Maybe<Array<Scalars['DateTime']['output']>>
  dataSources?: Maybe<Array<Scalars['ID']['output']>>
  endVisibleTime?: Maybe<Scalars['DateTime']['output']>
  finishTime?: Maybe<Scalars['DateTime']['output']>
  groupId: Scalars['ID']['output']
  groupName?: Maybe<Scalars['String']['output']>
  isAllPagesLinked?: Maybe<Scalars['Boolean']['output']>
  pageBucketIds?: Maybe<Array<Scalars['ID']['output']>>
  pageIds: Array<Scalars['ID']['output']>
  startVisibleTime?: Maybe<Scalars['DateTime']['output']>
}

export type CountdownTimerAggregationSettingItemInput = {
  bonusFinishTimes?: InputMaybe<Array<Scalars['DateTime']['input']>>
  endVisibleTime?: InputMaybe<Scalars['DateTime']['input']>
  finishTime?: InputMaybe<Scalars['DateTime']['input']>
  groupId: Scalars['ID']['input']
  groupName?: InputMaybe<Scalars['String']['input']>
  pageBucketIds?: InputMaybe<Array<Scalars['ID']['input']>>
  pageIds: Array<Scalars['ID']['input']>
  startVisibleTime?: InputMaybe<Scalars['DateTime']['input']>
}

export type CountdownTimerInput = {
  componentId: Scalars['ID']['input']
  end?: InputMaybe<Scalars['DateTime']['input']>
  finish?: InputMaybe<Scalars['DateTime']['input']>
  hideBeforeStart?: InputMaybe<Scalars['Boolean']['input']>
  hideOnEnd?: InputMaybe<Scalars['Boolean']['input']>
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  start?: InputMaybe<Scalars['DateTime']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  type: ComponentTypeInput
}

export enum CountdownTimerVariation {
  Compact = 'Compact',
  Full = 'Full',
}

export type CreateBrandingApiResponse = {
  __typename?: 'CreateBrandingAPIResponse'
  brandingId: Scalars['ID']['output']
}

export type CreateBrandingInput = {
  isDefault: Scalars['Boolean']['input']
  logoFileContentType: Scalars['String']['input']
  name: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type CreateBrandingResponse = {
  __typename?: 'CreateBrandingResponse'
  id: Scalars['ID']['output']
}

export type CreateCampaignApiResponse = {
  __typename?: 'CreateCampaignAPIResponse'
  campaignId: Scalars['ID']['output']
  campaignTitle: Scalars['String']['output']
  campaignType: CampaignType
  endDate?: Maybe<Scalars['String']['output']>
  goal?: Maybe<Scalars['Float']['output']>
  startDate?: Maybe<Scalars['String']['output']>
}

export type CreateCampaignInput = {
  endAt?: InputMaybe<Scalars['String']['input']>
  goal?: InputMaybe<Scalars['Float']['input']>
  startAt?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  type: CampaignType
}

export type CreateCharityInput = {
  abn?: InputMaybe<Scalars['String']['input']>
  auth0Id: Scalars['String']['input']
  name: Scalars['String']['input']
}

export type CreateCharityResult = {
  __typename?: 'CreateCharityResult'
  charityId: Scalars['String']['output']
  charityUserId: Scalars['String']['output']
}

export type CreateManualDonationInput = {
  address?: InputMaybe<AddressInput>
  amount: Scalars['Float']['input']
  campaignId: Scalars['ID']['input']
  comment?: InputMaybe<Scalars['String']['input']>
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  isAnonymous: Scalars['Boolean']['input']
  lastName: Scalars['String']['input']
  mobile?: InputMaybe<Scalars['String']['input']>
  mode: Mode
  organisation?: InputMaybe<Scalars['String']['input']>
  pageId: Scalars['ID']['input']
  paymentMethodId: Scalars['String']['input']
  profileId?: InputMaybe<Scalars['ID']['input']>
  profileName?: InputMaybe<Scalars['String']['input']>
  receiptOption: GivingReceiptOptionSetting
  stripeCustomerId: Scalars['String']['input']
}

export type CreateManualSubscriptionInput = {
  address?: InputMaybe<AddressInput>
  amount: Scalars['Float']['input']
  campaignId: Scalars['ID']['input']
  comment?: InputMaybe<Scalars['String']['input']>
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  givingFrequency: DonationFrequency
  isAnonymous: Scalars['Boolean']['input']
  lastName: Scalars['String']['input']
  mobile?: InputMaybe<Scalars['String']['input']>
  mode: Mode
  nextPaymentDate: Scalars['String']['input']
  organisation?: InputMaybe<Scalars['String']['input']>
  pageId: Scalars['ID']['input']
  paymentMethodId: Scalars['String']['input']
  profileId?: InputMaybe<Scalars['ID']['input']>
  profileName?: InputMaybe<Scalars['String']['input']>
  receiptOption: SubscriptionReceiptOptionSetting
  stripeCustomerId: Scalars['String']['input']
}

export type CreateOfflineDonationInput = {
  address?: InputMaybe<AddressInput>
  amount: Scalars['Float']['input']
  campaignId: Scalars['ID']['input']
  comment?: InputMaybe<Scalars['String']['input']>
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  isAnonymous: Scalars['Boolean']['input']
  lastName: Scalars['String']['input']
  mobile?: InputMaybe<Scalars['String']['input']>
  mode: Mode
  organisation?: InputMaybe<Scalars['String']['input']>
  pageId: Scalars['ID']['input']
  postComment?: Scalars['Boolean']['input']
  profileId?: InputMaybe<Scalars['ID']['input']>
  profileName?: InputMaybe<Scalars['String']['input']>
  sendReceipt: Scalars['Boolean']['input']
}

export type CreateOrderInput = {
  campaignId: Scalars['ID']['input']
  cancelUrl: Scalars['String']['input']
  charityId: Scalars['ID']['input']
  currency: Scalars['String']['input']
  deviceUUID?: InputMaybe<Scalars['String']['input']>
  donationFormAmount: Scalars['Float']['input']
  donationPageUrl: Scalars['String']['input']
  donorPaysAmount?: InputMaybe<Scalars['Float']['input']>
  email: Scalars['String']['input']
  eventId?: InputMaybe<Scalars['String']['input']>
  fbc?: InputMaybe<Scalars['String']['input']>
  fbp?: InputMaybe<Scalars['String']['input']>
  isDonorChooseToPayFee?: InputMaybe<Scalars['Boolean']['input']>
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  pageBucketId?: InputMaybe<Scalars['ID']['input']>
  pageId: Scalars['ID']['input']
  profileId?: InputMaybe<Scalars['ID']['input']>
  profileName?: InputMaybe<Scalars['String']['input']>
  returnUrl: Scalars['String']['input']
}

export type CreateOrderResponse = {
  __typename?: 'CreateOrderResponse'
  aggregateId: Scalars['String']['output']
  id?: Maybe<Scalars['String']['output']>
  orderUrl?: Maybe<Scalars['String']['output']>
  payerActionUrl?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
}

export type CreatePageBucketInput = {
  campaignId: Scalars['ID']['input']
  pageId: Scalars['ID']['input']
}

export type CreatePageInput = {
  campaignId: Scalars['ID']['input']
  htmlLayout?: InputMaybe<Scalars['String']['input']>
  pageLayout?: InputMaybe<PageLayoutInput>
  pageName?: InputMaybe<Scalars['String']['input']>
  pageType: PageType
}

export type CreatePageStateInput = {
  campaignId: Scalars['ID']['input']
  htmlLayout?: InputMaybe<Scalars['String']['input']>
  isPartOfGivingDayInit?: InputMaybe<Scalars['Boolean']['input']>
  pageBucketId?: InputMaybe<Scalars['ID']['input']>
  pageLayout?: InputMaybe<PageLayoutInput>
  pageName?: InputMaybe<Scalars['String']['input']>
}

export type CreatePaymentIntentInput = {
  campaignId: Scalars['ID']['input']
  charityId: Scalars['ID']['input']
  currency: Scalars['String']['input']
  deviceUUID?: InputMaybe<Scalars['String']['input']>
  donationFormAmount: Scalars['Float']['input']
  donationPageUrl: Scalars['String']['input']
  donorPaysAmount?: InputMaybe<Scalars['Float']['input']>
  email: Scalars['String']['input']
  eventId?: InputMaybe<Scalars['String']['input']>
  fbc?: InputMaybe<Scalars['String']['input']>
  fbp?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  isDonorChooseToPayFee?: InputMaybe<Scalars['Boolean']['input']>
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  pageBucketId?: InputMaybe<Scalars['ID']['input']>
  pageId: Scalars['ID']['input']
  paymentMethodType: PaymentMethodType
  profileId?: InputMaybe<Scalars['ID']['input']>
  profileName?: InputMaybe<Scalars['String']['input']>
}

export type CreatePaymentIntentResponse = {
  __typename?: 'CreatePaymentIntentResponse'
  clientSecret: Scalars['String']['output']
  paymentIntentId?: Maybe<Scalars['String']['output']>
  paymentTransactionId: Scalars['String']['output']
}

export type CreatePaypalReferralLinkInput = {
  merchantEmail: Scalars['String']['input']
  mode: Mode
}

export type CreatePaypalReferralLinkResponse = {
  __typename?: 'CreatePaypalReferralLinkResponse'
  merchantEmail: Scalars['String']['output']
  referralLink: Scalars['String']['output']
  referralToken: Scalars['String']['output']
}

export type CreateProfileCategoryInput = {
  campaignId: Scalars['ID']['input']
  name: Scalars['String']['input']
  pageId?: InputMaybe<Scalars['ID']['input']>
  type: ProfileEntity
}

export type CreateSubscriptionInput = {
  campaignId: Scalars['ID']['input']
  charityId: Scalars['ID']['input']
  currency: Scalars['String']['input']
  deviceUUID?: InputMaybe<Scalars['String']['input']>
  donationFormAmount: Scalars['Float']['input']
  donationPageUrl: Scalars['String']['input']
  donorPaysAmount?: InputMaybe<Scalars['Float']['input']>
  email: Scalars['String']['input']
  eventId?: InputMaybe<Scalars['String']['input']>
  fbc?: InputMaybe<Scalars['String']['input']>
  fbp?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  givingFrequency: DonationFrequency
  installment?: InputMaybe<InstallmentInput>
  isDonorChooseToPayFee?: InputMaybe<Scalars['Boolean']['input']>
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  pageBucketId?: InputMaybe<Scalars['ID']['input']>
  pageId: Scalars['ID']['input']
  paymentMethodType: PaymentMethodType
  profileId?: InputMaybe<Scalars['ID']['input']>
  profileName?: InputMaybe<Scalars['String']['input']>
}

export type CreateSubscriptionResponse = {
  __typename?: 'CreateSubscriptionResponse'
  clientSecret: Scalars['String']['output']
  paymentSubscriptionId: Scalars['String']['output']
  subscriptionId: Scalars['String']['output']
}

export type CreateTemplateInput = {
  htmlLayout?: InputMaybe<Scalars['String']['input']>
  layout: PageLayoutInput
  name: Scalars['String']['input']
  pageType: PageType
  screenshotImageUrl?: InputMaybe<Scalars['String']['input']>
  type: CharityTemplateType
}

export type CreateUserForCharityInput = {
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
  roleId: Scalars['String']['input']
}

export type CustomField = {
  __typename?: 'CustomField'
  acceptedValues?: Maybe<Array<CustomFieldValue>>
  elementType: CustomFieldElementType
  fieldDescription?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type CustomFieldElementInput = {
  acceptedValues?: InputMaybe<Array<CustomFieldValueInput>>
  customFieldSettingId: Scalars['ID']['input']
  defaultValue?: InputMaybe<Scalars['String']['input']>
  elementType: CustomFieldElementType
  fieldDescription?: InputMaybe<Scalars['String']['input']>
  fieldType: CustomFieldType
  isRequired: Scalars['Boolean']['input']
  label: Scalars['String']['input']
}

export enum CustomFieldElementType {
  Checkbox = 'Checkbox',
  DatePicker = 'DatePicker',
  Dropdown = 'Dropdown',
  Hidden = 'Hidden',
  InputText = 'InputText',
  MultiSelect = 'MultiSelect',
  RadioButton = 'RadioButton',
  SingleSelect = 'SingleSelect',
  Switch = 'Switch',
  TextArea = 'TextArea',
}

export type CustomFieldInput = {
  acceptedValues?: InputMaybe<Array<CustomFieldValueInput>>
  elementType: CustomFieldElementType
  fieldDescription?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  name: Scalars['String']['input']
}

export type CustomFieldSetting = {
  __typename?: 'CustomFieldSetting'
  acceptedValues?: Maybe<Array<CustomFieldValue>>
  defaultValue?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  elementType: CustomFieldElementType
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  type: CustomFieldType
}

export type CustomFieldSettingInput = {
  acceptedValues?: InputMaybe<Array<CustomFieldValueInput>>
  defaultValue?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  elementType: CustomFieldElementType
  id?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  type: CustomFieldType
}

export enum CustomFieldType {
  Address = 'Address',
  Custom = 'Custom',
  DateOfBirth = 'DateOfBirth',
}

export type CustomFieldValue = {
  __typename?: 'CustomFieldValue'
  key: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type CustomFieldValueInput = {
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type DateTimeTrigger = {
  __typename?: 'DateTimeTrigger'
  amountTriggers: Array<AmountTrigger>
  dateTimeStart: Scalars['DateTime']['output']
  pageId: Scalars['ID']['output']
}

export type DateTimeTriggerInput = {
  amountTriggers: Array<AmountTriggerInput>
  dateTimeStart: Scalars['DateTime']['input']
  pageId: Scalars['ID']['input']
}

export type DeleteAnalyticsSettingInput = {
  settingId: Scalars['String']['input']
  type?: InputMaybe<AnalyticsType>
}

export type DeleteCampaignInput = {
  campaignId: Scalars['ID']['input']
}

export type DeletePageInput = {
  campaignId: Scalars['ID']['input']
  pageId: Scalars['ID']['input']
  pageType: PageType
}

export type DollarHandle = {
  __typename?: 'DollarHandle'
  amount: Scalars['Int']['output']
  description?: Maybe<Scalars['String']['output']>
  hasDescription?: Maybe<Scalars['Boolean']['output']>
  hasImage?: Maybe<Scalars['Boolean']['output']>
  imageUrl?: Maybe<Scalars['String']['output']>
  isPersonalised?: Maybe<Scalars['Boolean']['output']>
  text?: Maybe<Text>
}

export type DollarHandleInput = {
  amount: Scalars['Int']['input']
  description?: InputMaybe<Scalars['String']['input']>
  hasDescription?: InputMaybe<Scalars['Boolean']['input']>
  hasImage?: InputMaybe<Scalars['Boolean']['input']>
  imageUrl?: InputMaybe<Scalars['String']['input']>
  isPersonalised?: InputMaybe<Scalars['Boolean']['input']>
  text?: InputMaybe<TextInput>
}

export type DollarHandles = Component & {
  __typename?: 'DollarHandles'
  dollarHandles: Array<DollarHandle>
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type DollarHandlesInput = {
  componentId: Scalars['ID']['input']
  dollarHandles: Array<DollarHandleInput>
  hasDescription?: InputMaybe<Scalars['Boolean']['input']>
  hasImage?: InputMaybe<Scalars['Boolean']['input']>
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  type: ComponentTypeInput
}

export type DonatedTo = {
  __typename?: 'DonatedTo'
  name: Scalars['String']['output']
  slug: Scalars['String']['output']
}

export type DonationForm = Component & {
  __typename?: 'DonationForm'
  dollarHandles: Array<DollarHandle>
  dollarHandlesDefault?: Maybe<Scalars['Int']['output']>
  donationFrequency: Array<DonationFrequency>
  donationFrequencyDefault?: Maybe<Scalars['Int']['output']>
  extraFields: Array<ExtraField>
  id: Scalars['ID']['output']
  legalUrl?: Maybe<Scalars['String']['output']>
  matchedGivings?: Maybe<Array<CampaignMatchedGivingSetting>>
  minimumAmount?: Maybe<Scalars['Int']['output']>
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  text?: Maybe<Text>
  title?: Maybe<Scalars['String']['output']>
  type: ComponentType
}

export type DonationFormInput = {
  componentId: Scalars['ID']['input']
  dollarHandles: Array<DollarHandleInput>
  dollarHandlesDefault?: InputMaybe<Scalars['Int']['input']>
  donationFrequency: Array<DonationFrequency>
  donationFrequencyDefault?: InputMaybe<Scalars['Int']['input']>
  extraFields: Array<ExtraFieldInput>
  legalUrl?: InputMaybe<Scalars['String']['input']>
  matchedGiving?: InputMaybe<MatchedGivingInput>
  minimumAmount?: InputMaybe<Scalars['Int']['input']>
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  text?: InputMaybe<TextInput>
  title?: InputMaybe<Scalars['String']['input']>
  type: ComponentTypeInput
}

export enum DonationFrequency {
  Every_4Weeks = 'EVERY_4_WEEKS',
  Fortnightly = 'FORTNIGHTLY',
  Monthly = 'MONTHLY',
  OneTime = 'ONE_TIME',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY',
}

export enum DonationFrequencyFilter {
  OnceOff = 'OnceOff',
  Recurring = 'Recurring',
}

export type DonationPagePaymentProviderSettings = {
  __typename?: 'DonationPagePaymentProviderSettings'
  payPalMerchantSetting?: Maybe<PayPalMerchantSetting>
  stripePaymentSettings?: Maybe<StripePaymentSettings>
}

export type DonorGiving = {
  __typename?: 'DonorGiving'
  amount: Scalars['Float']['output']
  campaignTitle?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  donationFrequencyType: GivingDonationFrequency
  givingId: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  paymentMethodType: PaymentMethodType
  status: GivingStatus
}

export type DonorGivingsQueryResult = {
  __typename?: 'DonorGivingsQueryResult'
  items: Array<DonorGiving>
  totalRecords: Scalars['Int']['output']
}

export type DonorPortalSlugResponse = {
  __typename?: 'DonorPortalSlugResponse'
  branding?: Maybe<Scalars['String']['output']>
  charityId: Scalars['ID']['output']
  donorPortalRegularGivingPermissions: CharityDonorPortalRegularGivingPermissions
}

export type DonorProfile = {
  __typename?: 'DonorProfile'
  firstName?: Maybe<Scalars['String']['output']>
  lastName?: Maybe<Scalars['String']['output']>
}

export type DonorSubscription = {
  __typename?: 'DonorSubscription'
  amount: Scalars['Float']['output']
  campaignTitle?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTime']['output']
  externalSubscriptionId: Scalars['String']['output']
  frequency: GivingDonationFrequency
  lastInvoice?: Maybe<SubscriptionInvoice>
  name?: Maybe<Scalars['String']['output']>
  nextPaymentDate?: Maybe<Scalars['DateTime']['output']>
  paymentMethodType: PaymentMethodType
  regularGivings: Array<DonorSubscriptionRegularGiving>
  resumeAt?: Maybe<Scalars['DateTime']['output']>
  scheduledUpdate?: Maybe<SubscriptionScheduledUpdate>
  status: SubscriptionStatus
  subscriptionEndDate?: Maybe<Scalars['DateTime']['output']>
  subscriptionId: Scalars['ID']['output']
  subscriptionStartDate: Scalars['DateTime']['output']
}

export type DonorSubscriptionRegularGiving = {
  __typename?: 'DonorSubscriptionRegularGiving'
  amount: Scalars['Float']['output']
  createdAt: Scalars['DateTime']['output']
  name?: Maybe<Scalars['String']['output']>
  paymentMethodType: PaymentMethodType
  regularGivingId: Scalars['ID']['output']
  status: GivingStatus
}

export type DonorSubscriptionsQueryResult = {
  __typename?: 'DonorSubscriptionsQueryResult'
  items: Array<DonorSubscription>
  totalRecords: Scalars['Int']['output']
}

export type DonorSummaryInput = {
  email: Scalars['String']['input']
  endDate: Scalars['DateTime']['input']
  isLiveMode: Scalars['Boolean']['input']
  startDate: Scalars['DateTime']['input']
}

export type DuplicateCampaignInput = {
  campaign: CreateCampaignInput
  campaignId: Scalars['ID']['input']
  duplicateSettings: Scalars['Boolean']['input']
  pagesToDuplicate: Array<Scalars['ID']['input']>
}

export type DuplicatePageInput = {
  campaignId: Scalars['ID']['input']
  pageId: Scalars['ID']['input']
  pageType: PageType
}

export type DuplicatePageStateInput = {
  campaignId: Scalars['ID']['input']
  pageBucketId: Scalars['ID']['input']
  pageId: Scalars['ID']['input']
  pageName?: InputMaybe<Scalars['String']['input']>
}

export type ElementSettings = {
  __typename?: 'ElementSettings'
  matchedGivings?: Maybe<Array<CampaignMatchedGivingSetting>>
  progressBar?: Maybe<ProgressBarAggregationSettingItem>
}

export type EmailReceiptSettingItem = {
  __typename?: 'EmailReceiptSettingItem'
  from?: Maybe<Scalars['String']['output']>
  receiptPageId: Scalars['ID']['output']
  replyTo?: Maybe<Scalars['String']['output']>
  subject?: Maybe<Scalars['String']['output']>
}

export type EmailReceiptSettings = {
  __typename?: 'EmailReceiptSettings'
  items?: Maybe<Array<EmailReceiptSettingItem>>
  profileRegisteredNotificationEmails?: Maybe<Array<PeerToPeerFundraiserRegistrationNotificationSettingValue>>
  profileRegisteredNotificationEmailsEnabled?: Maybe<Scalars['Boolean']['output']>
  receiptOptionSetting?: Maybe<ReceiptOptionSetting>
}

export type Empty = Component & {
  __typename?: 'Empty'
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type ExchangeStripeOAuthInput = {
  code: Scalars['String']['input']
  state: Scalars['String']['input']
}

export type ExtraField = {
  __typename?: 'ExtraField'
  conditionalFields?: Maybe<Array<ExtraField>>
  customField?: Maybe<CustomField>
  defaultValue?: Maybe<Scalars['String']['output']>
  hideLabel?: Maybe<Scalars['Boolean']['output']>
  isHidden?: Maybe<Scalars['Boolean']['output']>
  isRequired: Scalars['Boolean']['output']
  label: Scalars['String']['output']
  name: Scalars['String']['output']
  order?: Maybe<Scalars['Int']['output']>
  placeholder?: Maybe<Scalars['String']['output']>
  type: ExtraFieldType
}

export type ExtraFieldInput = {
  conditionalFields?: InputMaybe<Array<ExtraFieldInput>>
  customField?: InputMaybe<CustomFieldInput>
  defaultValue?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  isHidden?: InputMaybe<Scalars['Boolean']['input']>
  isRequired: Scalars['Boolean']['input']
  label: Scalars['String']['input']
  name: Scalars['String']['input']
  order?: InputMaybe<Scalars['Int']['input']>
  placeholder?: InputMaybe<Scalars['String']['input']>
  type: ExtraFieldType
}

export enum ExtraFieldType {
  Address = 'Address',
  Comments = 'Comments',
  Custom = 'Custom',
  DedicateTo = 'DedicateTo',
  Email = 'Email',
  Phone = 'Phone',
  Profile = 'Profile',
  Text = 'Text',
}

export type FeatureFlag = {
  __typename?: 'FeatureFlag'
  enabled: Scalars['Boolean']['output']
  key: Scalars['String']['output']
}

export type FeeRange = {
  __typename?: 'FeeRange'
  endRange?: Maybe<Scalars['Float']['output']>
  fixFee?: Maybe<Scalars['Float']['output']>
  percentageFee?: Maybe<Scalars['Float']['output']>
  startRange?: Maybe<Scalars['Float']['output']>
}

export type FindCampaignAssetsResponse = {
  __typename?: 'FindCampaignAssetsResponse'
  assetId: Scalars['ID']['output']
  categoryType?: Maybe<AssetCategoryType>
  fileName: Scalars['String']['output']
  url: Scalars['String']['output']
}

export type Footer = Component & {
  __typename?: 'Footer'
  id: Scalars['ID']['output']
  keyInformation?: Maybe<Text>
  keyInformationText?: Maybe<Scalars['String']['output']>
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  taxDeductible?: Maybe<Text>
  taxDeductibleText?: Maybe<Scalars['String']['output']>
  type: ComponentType
}

export type FooterInput = {
  componentId: Scalars['ID']['input']
  keyInformation?: InputMaybe<TextInput>
  keyInformationText?: InputMaybe<Scalars['String']['input']>
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  taxDeductible?: InputMaybe<TextInput>
  taxDeductibleText?: InputMaybe<Scalars['String']['input']>
  type: ComponentTypeInput
}

export type FormCustomFieldInput = {
  customFieldSettingId?: InputMaybe<Scalars['ID']['input']>
  name: Scalars['String']['input']
  values: Array<Scalars['String']['input']>
}

export type FormData = {
  __typename?: 'FormData'
  formId: Scalars['ID']['output']
  formValues: Array<FormValue>
  id: Scalars['ID']['output']
}

export type FormDataQueryResult = {
  __typename?: 'FormDataQueryResult'
  formData: Array<FormData>
  headers: Array<Scalars['String']['output']>
}

export type FormValue = {
  __typename?: 'FormValue'
  customFieldSettingId?: Maybe<Scalars['ID']['output']>
  name?: Maybe<Scalars['String']['output']>
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>
}

export type FundraiserButton = Component & {
  __typename?: 'FundraiserButton'
  id: Scalars['ID']['output']
  loginForm: LoginForm
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  registerForm: RegisterForm
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type FundraiserButtonInput = {
  componentId: Scalars['ID']['input']
  loginForm: LoginFormInput
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  registerForm: RegisterFormInput
  styles?: InputMaybe<Scalars['JSON']['input']>
  type: ComponentTypeInput
}

export type FundraiserProfile = Component & {
  __typename?: 'FundraiserProfile'
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type FundraiserProfileInput = {
  componentId: Scalars['ID']['input']
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  subComponents: Scalars['JSON']['input']
  type: ComponentTypeInput
}

export type FundraiserProfileSubcomponents = {
  __typename?: 'FundraiserProfileSubcomponents'
  profileName: Scalars['ID']['output']
  socialShare?: Maybe<Scalars['ID']['output']>
}

export type FundraiserRegistrationEmailInput = {
  displayName: Scalars['String']['input']
  email: Scalars['String']['input']
}

export type Ga4IntegrationSetting = {
  __typename?: 'Ga4IntegrationSetting'
  measurementId: Scalars['String']['output']
  name: Scalars['String']['output']
  settingId: Scalars['ID']['output']
}

export type Ga4IntegrationSettingInput = {
  measurementId: Scalars['String']['input']
  name: Scalars['String']['input']
}

export type GetCampaignPaymentSettingsApiResponse = {
  __typename?: 'GetCampaignPaymentSettingsAPIResponse'
  payPalSetting?: Maybe<CharityPayPalSettings>
  platformFeeType?: Maybe<PlatformFeeType>
  stripeSetting?: Maybe<CharityStripeSettings>
}

export type GetCampaignPerformanceStatsQueryResult = {
  __typename?: 'GetCampaignPerformanceStatsQueryResult'
  averageDonationAmount: Scalars['Float']['output']
  donationAmounts: Array<CampaignDonorAmountStat>
  donationCount: Scalars['Int']['output']
  donationsByDates: Array<CampaignDonationByDateStat>
  pageDonationAmounts: Array<CampaignPageDonationAmountStat>
  totalAmount: Scalars['Float']['output']
  utmTagDonationAmounts: Array<CampaignUtmTagDonationAmountStat>
}

export type Giving = {
  __typename?: 'Giving'
  campaign: GivingCampaignDetail
  comment?: Maybe<GivingCommentDetail>
  createdAt: Scalars['DateTime']['output']
  currencyCode: Scalars['String']['output']
  donatedAmount: Scalars['Float']['output']
  donationFrequency: GivingDonationFrequency
  donor?: Maybe<GivingDonorDetail>
  donorPaysAmount?: Maybe<Scalars['Float']['output']>
  givingId: Scalars['ID']['output']
  page: GivingPageDetail
  paymentMethodType: PaymentMethodType
  paypal?: Maybe<GivingPaypalTransactionDetail>
  platformFeesAmount?: Maybe<Scalars['Float']['output']>
  refundedAmount: Scalars['Float']['output']
  status: GivingStatus
  stripe?: Maybe<GivingStripeTransactionDetail>
  transactionId?: Maybe<Scalars['ID']['output']>
}

export type GivingCampaignDetail = {
  __typename?: 'GivingCampaignDetail'
  campaignId: Scalars['String']['output']
  campaignTitle?: Maybe<Scalars['String']['output']>
}

export type GivingCommentDetail = {
  __typename?: 'GivingCommentDetail'
  commentId: Scalars['ID']['output']
  message?: Maybe<Scalars['String']['output']>
}

export enum GivingDonationFrequency {
  Every4Weeks = 'Every4Weeks',
  Fortnightly = 'Fortnightly',
  Monthly = 'Monthly',
  OneTime = 'OneTime',
  Quarterly = 'Quarterly',
  Weekly = 'Weekly',
  Yearly = 'Yearly',
}

export type GivingDonorDetail = {
  __typename?: 'GivingDonorDetail'
  donationFormFirstName?: Maybe<Scalars['String']['output']>
  donationFormLastName?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  externalFirstName?: Maybe<Scalars['String']['output']>
  externalLastName?: Maybe<Scalars['String']['output']>
  fullName?: Maybe<Scalars['String']['output']>
}

export enum GivingFrequencyType {
  OneOff = 'OneOff',
  Recurring = 'Recurring',
}

export type GivingPageDetail = {
  __typename?: 'GivingPageDetail'
  pageId: Scalars['ID']['output']
  pageName?: Maybe<Scalars['String']['output']>
}

export type GivingPaypalTransactionDetail = {
  __typename?: 'GivingPaypalTransactionDetail'
  captureId?: Maybe<Scalars['String']['output']>
  orderId: Scalars['String']['output']
}

export enum GivingReceiptOptionSetting {
  Always = 'Always',
  None = 'None',
}

export enum GivingStatus {
  Cancelled = 'Cancelled',
  Failed = 'Failed',
  Incomplete = 'Incomplete',
  PartiallyRefunded = 'PartiallyRefunded',
  Pending = 'Pending',
  Refunded = 'Refunded',
  Succeeded = 'Succeeded',
  Unknown = 'Unknown',
}

export type GivingStripeTransactionDetail = {
  __typename?: 'GivingStripeTransactionDetail'
  paymentIntentId?: Maybe<Scalars['String']['output']>
}

export enum GivingType {
  Facebook = 'Facebook',
  Internal = 'Internal',
  Offline = 'Offline',
}

export type GivingsFilterInput = {
  donationFrequency?: InputMaybe<DonationFrequencyFilter>
  mode?: InputMaybe<Mode>
  paymentMethod?: InputMaybe<PaymentMethodType>
  search?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<GivingStatus>
}

export type GivingsQueryInput = {
  endDate?: InputMaybe<Scalars['String']['input']>
  filter?: InputMaybe<GivingsFilterInput>
  pageNumber: Scalars['Int']['input']
  pageSize?: InputMaybe<Scalars['Int']['input']>
  startDate?: InputMaybe<Scalars['String']['input']>
}

export type GivingsQueryResult = {
  __typename?: 'GivingsQueryResult'
  items: Array<Giving>
  totalRecords: Scalars['Int']['output']
}

export type GtmIntegrationSetting = {
  __typename?: 'GtmIntegrationSetting'
  name: Scalars['String']['output']
  settingId: Scalars['ID']['output']
  tagId: Scalars['String']['output']
}

export type GtmIntegrationSettingInput = {
  name: Scalars['String']['input']
  tagId: Scalars['String']['input']
}

export type Header = Component & {
  __typename?: 'Header'
  hasDonateButton: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type HeaderInput = {
  componentId: Scalars['ID']['input']
  hasDonateButton: Scalars['Boolean']['input']
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  type: ComponentTypeInput
}

export type IdentityPartnerSetting = {
  __typename?: 'IdentityPartnerSetting'
  items: Array<MoveDataIntegrationSetting>
}

export type IdentityPartnerSettingInput = {
  settingId?: InputMaybe<Scalars['ID']['input']>
  webhookUrl: Scalars['String']['input']
}

export type Image = Component & {
  __typename?: 'Image'
  alt?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  mergeFieldId?: Maybe<Scalars['String']['output']>
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
  url?: Maybe<Scalars['String']['output']>
}

export type ImageInput = {
  alt?: InputMaybe<Scalars['String']['input']>
  componentId: Scalars['ID']['input']
  mergeFieldId?: InputMaybe<Scalars['String']['input']>
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  type: ComponentTypeInput
  url?: InputMaybe<Scalars['String']['input']>
}

export type InitCampaignInput = {
  campaignId: Scalars['ID']['input']
  campaignType: CampaignType
  templateId: Scalars['ID']['input']
  templateType: TemplateType
}

export type InstallmentInput = {
  totalAmount?: InputMaybe<Scalars['Float']['input']>
  totalNumberOfInstallments: Scalars['Int']['input']
}

export type Leaderboard = Component & {
  __typename?: 'Leaderboard'
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type LeaderboardInput = {
  componentId: Scalars['ID']['input']
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  subComponents: Scalars['JSON']['input']
  type: ComponentTypeInput
}

export type LoginForm = Component & {
  __typename?: 'LoginForm'
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type LoginFormInput = {
  componentId: Scalars['ID']['input']
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  subComponents: Scalars['JSON']['input']
  type: ComponentTypeInput
}

export type LoginFormSubcomponents = {
  __typename?: 'LoginFormSubcomponents'
  title?: Maybe<Scalars['ID']['output']>
}

export type MatchedGivingAggregationSetting = AggregationSetting & {
  __typename?: 'MatchedGivingAggregationSetting'
  groupSettings?: Maybe<Array<MatchedGivingAggregationSettingItem>>
  isAllPagesLinked?: Maybe<Scalars['Boolean']['output']>
}

export type MatchedGivingAggregationSettingItem = AggregationSettingItem & {
  __typename?: 'MatchedGivingAggregationSettingItem'
  dataSources?: Maybe<Array<Scalars['ID']['output']>>
  groupId: Scalars['ID']['output']
  groupName?: Maybe<Scalars['String']['output']>
  isAllPagesLinked?: Maybe<Scalars['Boolean']['output']>
  matchedGivingSettingIds: Array<Scalars['ID']['output']>
  pageBucketIds?: Maybe<Array<Scalars['ID']['output']>>
  pageIds: Array<Scalars['ID']['output']>
}

export type MatchedGivingAggregationSettingItemInput = {
  groupId: Scalars['ID']['input']
  groupName?: InputMaybe<Scalars['String']['input']>
  matchedGivingSettingIds: Array<Scalars['ID']['input']>
  pageBucketIds?: InputMaybe<Array<Scalars['ID']['input']>>
  pageIds: Array<Scalars['ID']['input']>
}

export type MatchedGivingInput = {
  accentColor?: InputMaybe<ColorInput>
  dollarCap?: InputMaybe<Scalars['Int']['input']>
  multiplier: Scalars['Int']['input']
}

export type MatchedGivingProgressResult = {
  __typename?: 'MatchedGivingProgressResult'
  amount: Scalars['Float']['output']
}

export type MatchedGivingQueryResult = {
  __typename?: 'MatchedGivingQueryResult'
  items: Array<MatchedGivingRecord>
  totalRecords: Scalars['Int']['output']
}

export type MatchedGivingRecord = {
  __typename?: 'MatchedGivingRecord'
  campaignTitle: Scalars['String']['output']
  createdAt: Scalars['DateTime']['output']
  donorEmail: Scalars['String']['output']
  donorName: Scalars['String']['output']
  givingAmount: Scalars['Float']['output']
  givingId: Scalars['ID']['output']
  matchedAmount: Scalars['Float']['output']
  matchedDonationAmount: Scalars['Float']['output']
  matchedGivingId: Scalars['ID']['output']
  matchedGivingSettingName: Scalars['String']['output']
  multiplier: Scalars['Int']['output']
  pageName: Scalars['String']['output']
  totalAmount: Scalars['Float']['output']
}

export type MergeField = {
  __typename?: 'MergeField'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  tag: Scalars['String']['output']
}

export type MergeFieldSetting = {
  __typename?: 'MergeFieldSetting'
  CsvHeader?: Maybe<Scalars['String']['output']>
  IsAnimated?: Maybe<Scalars['Boolean']['output']>
  MergeFieldName: Scalars['String']['output']
  MergeFieldSettingId: Scalars['String']['output']
  MergeTag: Scalars['String']['output']
  MergeTagDisplayText?: Maybe<Scalars['String']['output']>
  MergeTagFallback?: Maybe<Scalars['String']['output']>
  MergeTagOptions?: Maybe<Scalars['JSON']['output']>
  MergeTagType?: Maybe<MergeTagType>
  QueryParameter: Scalars['String']['output']
  TemplateName?: Maybe<Scalars['String']['output']>
}

export enum MergeTagType {
  Dynamic = 'Dynamic',
  Formula = 'Formula',
  Link = 'Link',
  Static = 'Static',
  Super = 'Super',
}

export type Metadata = {
  __typename?: 'Metadata'
  campaign?: Maybe<CampaignMetadata>
  charity?: Maybe<CharityMetadata>
  page?: Maybe<PageMetadata>
}

export enum Mode {
  Live = 'Live',
  Test = 'Test',
}

export type MoveDataIntegrationSetting = {
  __typename?: 'MoveDataIntegrationSetting'
  settingId?: Maybe<Scalars['ID']['output']>
  webhookUrl: Scalars['String']['output']
}

export type Mutation = {
  __typename?: 'Mutation'
  addCampaignDomain: Scalars['ID']['output']
  addCampaignMatchedGivingSetting: AddCampaignMatchedGivingSettingResult
  addCustomFieldSetting: CustomFieldSetting
  addGa4Setting?: Maybe<Scalars['ID']['output']>
  addGtmSetting?: Maybe<Scalars['ID']['output']>
  addMergeField: Scalars['ID']['output']
  addPageBucketSlugsForCampaign?: Maybe<Array<Scalars['ID']['output']>>
  addPageSlugsForCampaign?: Maybe<Array<Scalars['ID']['output']>>
  addPayPalByReferral?: Maybe<Scalars['String']['output']>
  addPixelConversionsApiSetting?: Maybe<Scalars['ID']['output']>
  addRaiserEdgeIntegrationSetting?: Maybe<Scalars['String']['output']>
  approveIdentityPartnerSettings?: Maybe<Scalars['Boolean']['output']>
  approveRaiserEdgeIntegrationSetting?: Maybe<Scalars['Boolean']['output']>
  authenticateDonorToken: Scalars['String']['output']
  authenticateProfile: AuthenticateProfileResponse
  authenticateToken: Scalars['String']['output']
  cancelSubscription?: Maybe<Scalars['Boolean']['output']>
  changeRole?: Maybe<Scalars['Boolean']['output']>
  connectStripeStandardAccountOAuth?: Maybe<Scalars['String']['output']>
  createBranding: CreateBrandingResponse
  createCampaign: Campaign
  createCharity: CreateCharityResult
  createManualDonation?: Maybe<Scalars['ID']['output']>
  createManualSubscription?: Maybe<Scalars['ID']['output']>
  createOfflineDonation?: Maybe<Scalars['ID']['output']>
  createOrder: CreateOrderResponse
  createPage: PageResponse
  createPageBucket: PageResponse
  createPageState: PageResponse
  createPaymentIntent: CreatePaymentIntentResponse
  createPaypalReferralLink: CreatePaypalReferralLinkResponse
  createProfileCategory: Scalars['ID']['output']
  createStripeSubscriptionDonorPortalLink: StripeSubscriptionDonorPortalLink
  createSubscription: CreateSubscriptionResponse
  createTemplate: Scalars['ID']['output']
  createThankYouPage: PageResponse
  createUserForCharity?: Maybe<Scalars['Boolean']['output']>
  deleteAnalyticsSetting?: Maybe<Scalars['ID']['output']>
  deleteCampaign: Scalars['ID']['output']
  deleteCampaignAsset?: Maybe<Scalars['Boolean']['output']>
  deletePage: Scalars['ID']['output']
  deleteTemplate: Scalars['ID']['output']
  deleteUserFromCharity?: Maybe<Scalars['Boolean']['output']>
  duplicateCampaign: Scalars['ID']['output']
  duplicatePage: PageResponse
  duplicatePageState: PageResponse
  duplicateThankYouPage: PageResponse
  exchangeStripeOAuthCode?: Maybe<Scalars['String']['output']>
  initCampaign: PageResponse
  initFundraiserPages?: Maybe<Scalars['Boolean']['output']>
  initGivingDayCampaign: PageResponse
  login: Scalars['String']['output']
  loginDonor: Scalars['String']['output']
  loginProfile: Scalars['String']['output']
  pauseSubscription?: Maybe<Scalars['Boolean']['output']>
  postComment: Scalars['Boolean']['output']
  publishPage: Array<PageDetail>
  publishThankYouPage: Array<PageDetail>
  recordStats?: Maybe<Scalars['Boolean']['output']>
  regenerateCustomerPortalSession: Scalars['Boolean']['output']
  registerEmail: RegisterEmailResponse
  registerProfile: RegisterProfileResult
  resendReceipt?: Maybe<Scalars['ID']['output']>
  resumeSubscription?: Maybe<SubscriptionStatus>
  saveDetails: PageResponse
  saveDraft: PageResponse
  savePageBucketDetails?: Maybe<Scalars['Boolean']['output']>
  savePageMetadata?: Maybe<Scalars['Boolean']['output']>
  saveThankYouPageDraft: PageResponse
  selectCharity?: Maybe<Scalars['Boolean']['output']>
  sendCharityTaxSummary: Scalars['Boolean']['output']
  sendTestEmail?: Maybe<Scalars['ID']['output']>
  setCampaignAnalyticsSettings: Scalars['ID']['output']
  setCampaignPayPalSettings: SetCampaignPaymentProviderSettingsResponse
  setCampaignPlatformFeeType?: Maybe<Scalars['ID']['output']>
  setCampaignStripeSettings: SetCampaignPaymentProviderSettingsResponse
  setCampaignTriggers?: Maybe<Scalars['String']['output']>
  setCharityBranding: Scalars['Boolean']['output']
  setCharityDetail: Scalars['ID']['output']
  setCharityDonorPortalPermissions?: Maybe<Scalars['Boolean']['output']>
  setCharityPageRedirectionSettings?: Maybe<Scalars['Boolean']['output']>
  setCharityPayPalSettings: SetPaymentProviderSettingsResponse
  setCharityPlatformFee?: Maybe<Scalars['String']['output']>
  setCharityStripeSettings: SetPaymentProviderSettingsResponse
  setCommentAggregationSetting: Scalars['Boolean']['output']
  setCountdownTimerAggregationSetting: Scalars['Boolean']['output']
  setDefaultCampaignPage: Scalars['Boolean']['output']
  setEmailReceiptOptions: Scalars['Boolean']['output']
  setEmailReceiptSetting: Scalars['Boolean']['output']
  setEmailSettings: Scalars['Boolean']['output']
  setFundraiserRegistrationNotificationsForProfile: Scalars['Boolean']['output']
  setMatchedGivingAggregationSetting: Scalars['Boolean']['output']
  setProgressBarAggregationSetting: Scalars['Boolean']['output']
  setReceiptPageReferences: Scalars['Boolean']['output']
  setThankYouPageReferences: Scalars['Boolean']['output']
  submitDonorSummary?: Maybe<Scalars['Boolean']['output']>
  submitFormValues: Scalars['Boolean']['output']
  submitPostDonationFormValues: Scalars['Boolean']['output']
  submitQuickPayValues: Scalars['Boolean']['output']
  toggleDonationNotificationForProfile: Scalars['Boolean']['output']
  toggleWelcomeEmailForProfile: Scalars['Boolean']['output']
  updateBranding: UpdateBrandingResponse
  updateCampaignTitle: Scalars['ID']['output']
  updateCustomFieldSetting: Scalars['ID']['output']
  updateGa4Setting?: Maybe<Scalars['ID']['output']>
  updateGtmSetting?: Maybe<Scalars['ID']['output']>
  updatePaymentIntent: UpdatePaymentIntentResponse
  updatePaymentIntentDetails: UpdatePaymentIntentResponse
  updatePixelConversionsApiSetting?: Maybe<Scalars['ID']['output']>
  updateProfile: Scalars['Boolean']['output']
  updateProfileAdmin: Scalars['Boolean']['output']
  updateSubscription: UpdateSubscriptionResponse
  updateSubscriptionAdmin?: Maybe<UpdateSubscriptionAdminResponse>
  updateSubscriptionDetails: UpdateSubscriptionResponse
  updateTemplate: Scalars['ID']['output']
  validateAndCreateCustomerPortalSession: Scalars['String']['output']
}

export type MutationAddCampaignDomainArgs = {
  addCampaignDomainInput: AddCampaignDomainInput
}

export type MutationAddCampaignMatchedGivingSettingArgs = {
  input: CampaignMatchedGivingSettingInput
}

export type MutationAddCustomFieldSettingArgs = {
  input: CustomFieldSettingInput
}

export type MutationAddGa4SettingArgs = {
  input: Ga4IntegrationSettingInput
}

export type MutationAddGtmSettingArgs = {
  input: GtmIntegrationSettingInput
}

export type MutationAddMergeFieldArgs = {
  input: AddMergeFieldInput
}

export type MutationAddPageBucketSlugsForCampaignArgs = {
  addPageBucketSlugsForCampaignInput?: InputMaybe<AddPageBucketSlugsForCampaignInput>
}

export type MutationAddPageSlugsForCampaignArgs = {
  addPageSlugsForCampaignInput?: InputMaybe<AddPageSlugsForCampaignInput>
}

export type MutationAddPayPalByReferralArgs = {
  input: AddPayPalByReferralInput
}

export type MutationAddPixelConversionsApiSettingArgs = {
  input: PixelConversionsApiIntegrationSettingInput
}

export type MutationAddRaiserEdgeIntegrationSettingArgs = {
  input: RaiserEdgeIntegrationSettingInput
}

export type MutationApproveIdentityPartnerSettingsArgs = {
  input: IdentityPartnerSettingInput
}

export type MutationApproveRaiserEdgeIntegrationSettingArgs = {
  code: Scalars['String']['input']
  state: Scalars['String']['input']
}

export type MutationAuthenticateDonorTokenArgs = {
  token: Scalars['String']['input']
}

export type MutationAuthenticateProfileArgs = {
  campaignId: Scalars['ID']['input']
  charityId: Scalars['ID']['input']
  encodedToken: Scalars['String']['input']
}

export type MutationAuthenticateTokenArgs = {
  token: Scalars['String']['input']
}

export type MutationCancelSubscriptionArgs = {
  input: CancelSubscriptionInput
}

export type MutationChangeRoleArgs = {
  mfaJwt: Scalars['String']['input']
  roleId: Scalars['String']['input']
  userId: Scalars['String']['input']
}

export type MutationConnectStripeStandardAccountOAuthArgs = {
  isLiveMode: Scalars['Boolean']['input']
}

export type MutationCreateBrandingArgs = {
  brandingInput: CreateBrandingInput
}

export type MutationCreateCampaignArgs = {
  campaignInput: CreateCampaignInput
}

export type MutationCreateCharityArgs = {
  charityInput: CreateCharityInput
}

export type MutationCreateManualDonationArgs = {
  input: CreateManualDonationInput
}

export type MutationCreateManualSubscriptionArgs = {
  input: CreateManualSubscriptionInput
}

export type MutationCreateOfflineDonationArgs = {
  input: CreateOfflineDonationInput
}

export type MutationCreateOrderArgs = {
  input: CreateOrderInput
}

export type MutationCreatePageArgs = {
  createPageInput: CreatePageInput
}

export type MutationCreatePageBucketArgs = {
  createPageBucketInput: CreatePageBucketInput
}

export type MutationCreatePageStateArgs = {
  createPageStateInput: CreatePageStateInput
}

export type MutationCreatePaymentIntentArgs = {
  input: CreatePaymentIntentInput
  ip?: InputMaybe<Scalars['String']['input']>
}

export type MutationCreatePaypalReferralLinkArgs = {
  input: CreatePaypalReferralLinkInput
}

export type MutationCreateProfileCategoryArgs = {
  input: CreateProfileCategoryInput
}

export type MutationCreateStripeSubscriptionDonorPortalLinkArgs = {
  input: StripeSubscriptionDonorPortalLinkInput
}

export type MutationCreateSubscriptionArgs = {
  input: CreateSubscriptionInput
  ip?: InputMaybe<Scalars['String']['input']>
}

export type MutationCreateTemplateArgs = {
  input: CreateTemplateInput
}

export type MutationCreateThankYouPageArgs = {
  createPageInput: CreatePageInput
}

export type MutationCreateUserForCharityArgs = {
  input: CreateUserForCharityInput
  mfaJwt: Scalars['String']['input']
}

export type MutationDeleteAnalyticsSettingArgs = {
  input: DeleteAnalyticsSettingInput
}

export type MutationDeleteCampaignArgs = {
  deleteCampaignInput: DeleteCampaignInput
}

export type MutationDeleteCampaignAssetArgs = {
  assetId: Scalars['ID']['input']
  campaignId: Scalars['ID']['input']
}

export type MutationDeletePageArgs = {
  deletePageInput: DeletePageInput
}

export type MutationDeleteTemplateArgs = {
  id: Scalars['ID']['input']
}

export type MutationDeleteUserFromCharityArgs = {
  mfaJwt: Scalars['String']['input']
  userId: Scalars['String']['input']
}

export type MutationDuplicateCampaignArgs = {
  duplicateCampaignInput: DuplicateCampaignInput
}

export type MutationDuplicatePageArgs = {
  duplicatePageInput: DuplicatePageInput
}

export type MutationDuplicatePageStateArgs = {
  duplicatePageStateInput: DuplicatePageStateInput
}

export type MutationDuplicateThankYouPageArgs = {
  duplicatePageInput: DuplicatePageInput
}

export type MutationExchangeStripeOAuthCodeArgs = {
  input: ExchangeStripeOAuthInput
}

export type MutationInitCampaignArgs = {
  initCampaignInput: InitCampaignInput
}

export type MutationInitFundraiserPagesArgs = {
  campaignId: Scalars['ID']['input']
}

export type MutationInitGivingDayCampaignArgs = {
  initCampaignInput: InitCampaignInput
}

export type MutationLoginArgs = {
  email: Scalars['String']['input']
}

export type MutationLoginDonorArgs = {
  email: Scalars['String']['input']
}

export type MutationLoginProfileArgs = {
  campaignId: Scalars['ID']['input']
  charityId: Scalars['ID']['input']
  email: Scalars['String']['input']
}

export type MutationPauseSubscriptionArgs = {
  input?: InputMaybe<PauseSubscriptionInput>
}

export type MutationPostCommentArgs = {
  comment: CommentInput
}

export type MutationPublishPageArgs = {
  publishPageInput?: InputMaybe<PublishPageInput>
}

export type MutationPublishThankYouPageArgs = {
  publishPageInput?: InputMaybe<PublishPageInput>
}

export type MutationRecordStatsArgs = {
  input: AnalyticsInput
  ip?: InputMaybe<Scalars['String']['input']>
}

export type MutationRegenerateCustomerPortalSessionArgs = {
  externalSubscriptionId: Scalars['String']['input']
}

export type MutationRegisterEmailArgs = {
  campaignId: Scalars['ID']['input']
  charityId: Scalars['ID']['input']
  email: Scalars['String']['input']
}

export type MutationRegisterProfileArgs = {
  input: RegisterProfileInput
  token: Scalars['String']['input']
}

export type MutationResendReceiptArgs = {
  input?: InputMaybe<ResendReceiptInput>
}

export type MutationResumeSubscriptionArgs = {
  input?: InputMaybe<ResumeSubscriptionInput>
}

export type MutationSaveDetailsArgs = {
  saveDetailsInput: SaveDetailsInput
}

export type MutationSaveDraftArgs = {
  saveDraftInput?: InputMaybe<SaveDraftInput>
}

export type MutationSavePageBucketDetailsArgs = {
  campaignId: Scalars['ID']['input']
  name?: InputMaybe<Scalars['String']['input']>
  pageBucketId: Scalars['ID']['input']
}

export type MutationSavePageMetadataArgs = {
  savePageMetadataInput?: InputMaybe<SavePageMetadataInput>
}

export type MutationSaveThankYouPageDraftArgs = {
  saveDraftInput?: InputMaybe<SaveDraftInput>
}

export type MutationSelectCharityArgs = {
  input: SelectCharityInput
}

export type MutationSendCharityTaxSummaryArgs = {
  input: SendCharityTaxSummaryInput
}

export type MutationSendTestEmailArgs = {
  sendTestReceiptInput?: InputMaybe<SendTestReceiptInput>
}

export type MutationSetCampaignAnalyticsSettingsArgs = {
  input: CampaignAnalyticsSettingsInput
}

export type MutationSetCampaignPayPalSettingsArgs = {
  input: SetCampaignPaymentProviderSettingsInput
}

export type MutationSetCampaignPlatformFeeTypeArgs = {
  input: SetCampaignPlatformFeeTypeInput
}

export type MutationSetCampaignStripeSettingsArgs = {
  input: SetCampaignPaymentProviderSettingsInput
}

export type MutationSetCampaignTriggersArgs = {
  input: CampaignTriggerInput
}

export type MutationSetCharityBrandingArgs = {
  brandingId: Scalars['ID']['input']
}

export type MutationSetCharityDetailArgs = {
  input: CharityDetailInput
}

export type MutationSetCharityDonorPortalPermissionsArgs = {
  input: CharityDonorPortalPermissionsInput
}

export type MutationSetCharityPageRedirectionSettingsArgs = {
  input: Array<CharityPageRedirectionSettingsInput>
}

export type MutationSetCharityPayPalSettingsArgs = {
  input: CharityPayPalSettingsInput
}

export type MutationSetCharityPlatformFeeArgs = {
  platformFeeType: PlatformFeeType
}

export type MutationSetCharityStripeSettingsArgs = {
  input: CharityStripeSettingsInput
}

export type MutationSetCommentAggregationSettingArgs = {
  campaignId: Scalars['ID']['input']
  input: Array<CommentAggregationSettingItemInput>
}

export type MutationSetCountdownTimerAggregationSettingArgs = {
  campaignId: Scalars['ID']['input']
  input: Array<CountdownTimerAggregationSettingItemInput>
}

export type MutationSetDefaultCampaignPageArgs = {
  input: SetDefaultCampaignPageInput
}

export type MutationSetEmailReceiptOptionsArgs = {
  input: SetEmailReceiptOptionsInput
}

export type MutationSetEmailReceiptSettingArgs = {
  input: SetEmailSettingItemInput
}

export type MutationSetEmailSettingsArgs = {
  input: SetCampaignEmailSettingInput
}

export type MutationSetFundraiserRegistrationNotificationsForProfileArgs = {
  input: SetFundraiserRegistrationNotificationsForProfileInput
}

export type MutationSetMatchedGivingAggregationSettingArgs = {
  campaignId: Scalars['ID']['input']
  input: Array<MatchedGivingAggregationSettingItemInput>
}

export type MutationSetProgressBarAggregationSettingArgs = {
  campaignId: Scalars['ID']['input']
  input: Array<ProgressBarAggregationSettingItemInput>
}

export type MutationSetReceiptPageReferencesArgs = {
  input: SetReceiptPageReferencesInput
}

export type MutationSetThankYouPageReferencesArgs = {
  input: SetThankYouPageReferencesInput
}

export type MutationSubmitDonorSummaryArgs = {
  input: DonorSummaryInput
}

export type MutationSubmitFormValuesArgs = {
  input: SubmitFormValuesInput
}

export type MutationSubmitPostDonationFormValuesArgs = {
  input: SubmitPostDonationFormValuesInput
}

export type MutationSubmitQuickPayValuesArgs = {
  input: QuickPayValuesInput
}

export type MutationToggleDonationNotificationForProfileArgs = {
  campaignId: Scalars['ID']['input']
  isEnabled: Scalars['Boolean']['input']
}

export type MutationToggleWelcomeEmailForProfileArgs = {
  campaignId: Scalars['ID']['input']
  isEnabled: Scalars['Boolean']['input']
}

export type MutationUpdateBrandingArgs = {
  brandingInput: UpdateBrandingInput
}

export type MutationUpdateCampaignTitleArgs = {
  campaignId: Scalars['ID']['input']
  campaignTitle: Scalars['String']['input']
}

export type MutationUpdateCustomFieldSettingArgs = {
  input: CustomFieldSettingInput
}

export type MutationUpdateGa4SettingArgs = {
  input: Array<UpdateGa4IntegrationSettingInput>
}

export type MutationUpdateGtmSettingArgs = {
  input: Array<UpdateGtmIntegrationSettingInput>
}

export type MutationUpdatePaymentIntentArgs = {
  input: UpdatePaymentInput
  ip?: InputMaybe<Scalars['String']['input']>
}

export type MutationUpdatePaymentIntentDetailsArgs = {
  input: UpdatePaymentDetailsInput
}

export type MutationUpdatePixelConversionsApiSettingArgs = {
  input: Array<UpdatePixelConversionsApiIntegrationSettingInput>
}

export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput
  token: Scalars['String']['input']
}

export type MutationUpdateProfileAdminArgs = {
  input: UpdateProfileInput
}

export type MutationUpdateSubscriptionArgs = {
  input: UpdatePaymentInput
  ip?: InputMaybe<Scalars['String']['input']>
}

export type MutationUpdateSubscriptionAdminArgs = {
  input: UpdateSubscriptionAdminInput
}

export type MutationUpdateSubscriptionDetailsArgs = {
  input: UpdatePaymentDetailsInput
}

export type MutationUpdateTemplateArgs = {
  input: UpdateTemplateInput
}

export type MutationValidateAndCreateCustomerPortalSessionArgs = {
  subscriptionId: Scalars['String']['input']
  tenantId: Scalars['ID']['input']
  token: Scalars['ID']['input']
}

export type OfflineTransactionExternalData = {
  __typename?: 'OfflineTransactionExternalData'
  offlineTransactionId: Scalars['String']['output']
}

export type OrderComponent = {
  __typename?: 'OrderComponent'
  childComponents?: Maybe<Array<OrderComponent>>
  id: Scalars['String']['output']
}

export type OrderComponentInput = {
  children?: InputMaybe<Array<OrderComponentInput>>
  componentId: Scalars['String']['input']
  displayIndex: Scalars['Int']['input']
}

export type Page = {
  __typename?: 'Page'
  branding?: Maybe<Scalars['String']['output']>
  charityPageTemplateId?: Maybe<Scalars['ID']['output']>
  charityPageTemplateVersion?: Maybe<Scalars['Int']['output']>
  components: Array<PageComponent>
  desktop: Array<OrderComponent>
  elementSettings?: Maybe<ElementSettings>
  footer?: Maybe<Footer>
  header?: Maybe<Header>
  id: Scalars['ID']['output']
  index: Scalars['Int']['output']
  mobile?: Maybe<Array<OrderComponent>>
  name?: Maybe<Scalars['String']['output']>
  versionNumber?: Maybe<Scalars['Int']['output']>
}

export type PageBucketDetail = {
  __typename?: 'PageBucketDetail'
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  pageIds?: Maybe<Array<Scalars['ID']['output']>>
  slug?: Maybe<Scalars['String']['output']>
}

export type PageBucketSlugsDetailsInput = {
  pageBucketId: Scalars['ID']['input']
  pageBucketSlug: Scalars['String']['input']
}

export type PageComponent =
  | Button
  | Column
  | Comments
  | CountdownTimer
  | DollarHandles
  | DonationForm
  | Empty
  | Footer
  | FundraiserButton
  | FundraiserProfile
  | Header
  | Image
  | Leaderboard
  | LoginForm
  | PageOptions
  | PostDonationForm
  | ProgressBar
  | ProgressImage
  | RegisterForm
  | Row
  | SocialShare
  | Text
  | Video
  | VirtualGiftSection

export type PageDetail = {
  __typename?: 'PageDetail'
  hasBeenPublished?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  index: Scalars['Int']['output']
  name?: Maybe<Scalars['String']['output']>
  pageBucketId?: Maybe<Scalars['ID']['output']>
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  screenshotImageUrl?: Maybe<Scalars['String']['output']>
  slug?: Maybe<Scalars['String']['output']>
  status: PageStatusType
  type?: Maybe<PageType>
}

export type PageLayoutInput = {
  branding: Scalars['String']['input']
  components: ComponentsInput
  desktop: Array<OrderComponentInput>
  footer?: InputMaybe<FooterInput>
  header?: InputMaybe<HeaderInput>
  htmlLayout?: InputMaybe<Scalars['String']['input']>
  mobile?: InputMaybe<Array<OrderComponentInput>>
}

export type PageMetadata = {
  __typename?: 'PageMetadata'
  OgDescription?: Maybe<Scalars['String']['output']>
  OgImage?: Maybe<Scalars['String']['output']>
  OgTitle?: Maybe<Scalars['String']['output']>
  pageKeywords?: Maybe<Scalars['String']['output']>
}

export type PageOptions = Component & {
  __typename?: 'PageOptions'
  faviconUrl?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  siteTitle?: Maybe<Scalars['String']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type PageOptionsInput = {
  componentId: Scalars['ID']['input']
  faviconUrl?: InputMaybe<Scalars['String']['input']>
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  siteTitle?: InputMaybe<Scalars['String']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  type: ComponentTypeInput
}

export enum PageRedirectType {
  Campaign = 'Campaign',
  External = 'External',
  Page = 'Page',
  PageBucket = 'PageBucket',
  Profile = 'Profile',
}

export type PageReference = {
  __typename?: 'PageReference'
  pageId: Scalars['ID']['output']
  receiptPageIds: Array<Scalars['ID']['output']>
  thankYouPageIds: Array<Scalars['ID']['output']>
}

export type PageResponse = {
  __typename?: 'PageResponse'
  id: Scalars['ID']['output']
}

export type PageSlugsDetailsInput = {
  pageId: Scalars['ID']['input']
  pageSlug: Scalars['String']['input']
}

export enum PageStatusType {
  Draft = 'Draft',
  Published = 'Published',
}

export enum PageType {
  DonationPage = 'DonationPage',
  EmbeddedDonationForm = 'EmbeddedDonationForm',
  FundraiserWelcomeEmail = 'FundraiserWelcomeEmail',
  GroupProfile = 'GroupProfile',
  Login = 'Login',
  Receipt = 'Receipt',
  Register = 'Register',
  SingleProfile = 'SingleProfile',
  ThankYouPage = 'ThankYouPage',
}

export type PaginationQuery = {
  pageNumber: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
  search?: InputMaybe<Scalars['String']['input']>
}

export type PaginationResponse = {
  __typename?: 'PaginationResponse'
  currentPage: Scalars['Int']['output']
  hasNext: Scalars['Boolean']['output']
  hasPrev: Scalars['Boolean']['output']
  next?: Maybe<Scalars['String']['output']>
  pageSize: Scalars['Int']['output']
  prev?: Maybe<Scalars['String']['output']>
  totalItems: Scalars['Int']['output']
  totalPages: Scalars['Int']['output']
}

export type PauseSubscriptionInput = {
  externalSubscriptionId: Scalars['String']['input']
  paymentSubscriptionId: Scalars['ID']['input']
  resumeAt?: InputMaybe<Scalars['DateTime']['input']>
}

export type PayPalMerchantSetting = {
  __typename?: 'PayPalMerchantSetting'
  clientId?: Maybe<Scalars['String']['output']>
  merchantEmail?: Maybe<Scalars['String']['output']>
  merchantId?: Maybe<Scalars['String']['output']>
}

export type PayPalTransactionExternalData = {
  __typename?: 'PayPalTransactionExternalData'
  captureId: Scalars['String']['output']
  merchantEmail: Scalars['String']['output']
  merchantId: Scalars['String']['output']
  orderId: Scalars['String']['output']
}

export enum PaymentCardType {
  Amex = 'Amex',
  Mastercard = 'Mastercard',
  Visa = 'Visa',
}

export enum PaymentChargeType {
  Destination = 'Destination',
  Direct = 'Direct',
}

export enum PaymentMethodType {
  ApplePay = 'ApplePay',
  CreditCard = 'CreditCard',
  DirectDebit = 'DirectDebit',
  GooglePay = 'GooglePay',
  Offline = 'Offline',
  PayPal = 'PayPal',
}

export enum PaymentProviderType {
  Offline = 'Offline',
  PayPal = 'PayPal',
  StripeCustom = 'StripeCustom',
  StripeStandard = 'StripeStandard',
}

export type PaymentSettings = {
  __typename?: 'PaymentSettings'
  donationPagePaymentProviderSettings: DonationPagePaymentProviderSettings
  donorPaysPlatformFees?: Maybe<Array<Maybe<PlatformFee>>>
  platformFeeType: PlatformFeeType
  tax?: Maybe<Tax>
}

export type PaymentTransaction = {
  __typename?: 'PaymentTransaction'
  applicationFeeTransaction?: Maybe<ApplicationFeeRefundTransactionDetail>
  createdAt: Scalars['DateTime']['output']
  givingId: Scalars['ID']['output']
  netPaymentTransactionAmount: Scalars['Float']['output']
  paymentTransaction?: Maybe<PaymentTransactionDetail>
  refundTransaction?: Maybe<RefundTransactionDetail>
  transactionExternalData: TransactionExternalData
}

export type PaymentTransactionDetail = {
  __typename?: 'PaymentTransactionDetail'
  charityTipAmount?: Maybe<Scalars['Float']['output']>
  donationFormAmount: Scalars['Float']['output']
  transactionAmount: Scalars['Float']['output']
  transactionFees: TransactionFees
}

export type PaymentTransactionQueryResult = {
  __typename?: 'PaymentTransactionQueryResult'
  items: Array<PaymentTransaction>
  totalRecords: Scalars['Int']['output']
}

export type Payout = {
  __typename?: 'Payout'
  applicationFeeTransaction?: Maybe<ApplicationFeeRefundTransactionDetail>
  endAt: Scalars['DateTime']['output']
  id: Scalars['ID']['output']
  paymentTransaction?: Maybe<PaymentTransactionDetail>
  payoutDate: Scalars['DateTime']['output']
  refundTransaction?: Maybe<RefundTransactionDetail>
  startAt: Scalars['DateTime']['output']
  status?: Maybe<PayoutStatus>
  transferAmount: Scalars['Float']['output']
}

export type PayoutQueryResult = {
  __typename?: 'PayoutQueryResult'
  items: Array<Payout>
  totalRecords: Scalars['Int']['output']
}

export enum PayoutStatus {
  Failed = 'Failed',
  Processing = 'Processing',
  Succeeded = 'Succeeded',
}

export type PeerToPeerFundraiserRegistrationNotificationSettingValue = {
  __typename?: 'PeerToPeerFundraiserRegistrationNotificationSettingValue'
  displayName: Scalars['String']['output']
  email: Scalars['String']['output']
}

export type PeerToPeerPageMapItem = {
  __typename?: 'PeerToPeerPageMapItem'
  categoryId?: Maybe<Scalars['String']['output']>
  pageId?: Maybe<Scalars['String']['output']>
}

export type PeerToPeerPageMapSettings = {
  __typename?: 'PeerToPeerPageMapSettings'
  multipleFundraiserPageIds?: Maybe<Array<PeerToPeerPageMapItem>>
  singleFundraiserPageIds?: Maybe<Array<PeerToPeerPageMapItem>>
}

export type PixelConversionsApiIntegrationSetting = {
  __typename?: 'PixelConversionsApiIntegrationSetting'
  isConversionsApi: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  pixelId: Scalars['String']['output']
  settingId: Scalars['ID']['output']
  testEventCode?: Maybe<Scalars['String']['output']>
}

export type PixelConversionsApiIntegrationSettingInput = {
  conversionsApiToken?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  pixelId: Scalars['String']['input']
  testEventCode?: InputMaybe<Scalars['String']['input']>
}

export type PlatformFee = {
  __typename?: 'PlatformFee'
  feeRanges?: Maybe<Array<FeeRange>>
  givingFrequencyType: GivingFrequencyType
  givingType: GivingType
  paymentProviderType: PaymentProviderType
  platformFeeType: PlatformFeeType
}

export enum PlatformFeeType {
  CharityPays = 'CharityPays',
  DonorPays = 'DonorPays',
}

export type PostDonationForm = Component & {
  __typename?: 'PostDonationForm'
  buttonText: Scalars['String']['output']
  extraFields: Array<ExtraField>
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type PostDonationFormInput = {
  buttonText: Scalars['String']['input']
  componentId: Scalars['ID']['input']
  extraFields: Array<ExtraFieldInput>
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  subComponents?: InputMaybe<Scalars['JSON']['input']>
  type: ComponentTypeInput
}

export type PostDonationFormSubcomponents = {
  __typename?: 'PostDonationFormSubcomponents'
  title?: Maybe<Scalars['ID']['output']>
}

export type PrevalidateDonation = {
  __typename?: 'PrevalidateDonation'
  campaignId: Scalars['ID']['output']
  charityId: Scalars['ID']['output']
  donationFormAmount: Scalars['Float']['output']
  ipAddress: Scalars['String']['output']
  pageId: Scalars['ID']['output']
}

export type PreviewCampaignPaymentSettings = {
  __typename?: 'PreviewCampaignPaymentSettings'
  hasPaypal?: Maybe<Scalars['Boolean']['output']>
  hasStripe?: Maybe<Scalars['Boolean']['output']>
  platformFeeType?: Maybe<PlatformFeeType>
}

export type PreviewQueryResult = {
  __typename?: 'PreviewQueryResult'
  campaignSettings?: Maybe<CampaignSettings>
  metadata?: Maybe<Metadata>
  page: Page
  profiles?: Maybe<Array<ProfileData>>
}

export type ProfileCategory = {
  __typename?: 'ProfileCategory'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  profileEntity?: Maybe<ProfileEntity>
}

export type ProfileData = {
  __typename?: 'ProfileData'
  campaignId?: Maybe<Scalars['ID']['output']>
  category?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  goal?: Maybe<Scalars['Float']['output']>
  id: Scalars['String']['output']
  isGivingNotificationEnabled?: Maybe<Scalars['Boolean']['output']>
  logoUrl?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  owner?: Maybe<ProfileOwnerData>
  profileUrl?: Maybe<Scalars['String']['output']>
  progressAmount?: Maybe<Scalars['Float']['output']>
  status?: Maybe<ProfileStatus>
}

export enum ProfileEntity {
  Group = 'Group',
  Single = 'Single',
}

export type ProfileOwnerData = {
  __typename?: 'ProfileOwnerData'
  email: Scalars['String']['output']
  firstName: Scalars['String']['output']
  lastName: Scalars['String']['output']
}

export enum ProfileQueryOrderType {
  DateAscending = 'DateAscending',
  DateDescending = 'DateDescending',
  TotalDescending = 'TotalDescending',
}

export enum ProfileStatus {
  Active = 'Active',
  Approved = 'Approved',
}

export type ProgressBar = Component & {
  __typename?: 'ProgressBar'
  bonusGoals?: Maybe<Array<BonusGoal>>
  end?: Maybe<Scalars['DateTime']['output']>
  finalGoal?: Maybe<BonusGoal>
  goals?: Maybe<Array<Scalars['Int']['output']>>
  hideBeforeStart?: Maybe<Scalars['Boolean']['output']>
  hideOnEnd?: Maybe<Scalars['Boolean']['output']>
  hideOnGoalReached?: Maybe<Scalars['Boolean']['output']>
  hideWhenMatchedGivingActive?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  isAllPagesLinked?: Maybe<Scalars['Boolean']['output']>
  linkedPageIds?: Maybe<Array<Scalars['ID']['output']>>
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  offset?: Maybe<Scalars['Float']['output']>
  start?: Maybe<Scalars['DateTime']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  text?: Maybe<Text>
  title?: Maybe<Scalars['String']['output']>
  type: ComponentType
}

export type ProgressBarAggregationSetting = AggregationSetting & {
  __typename?: 'ProgressBarAggregationSetting'
  groupSettings?: Maybe<Array<ProgressBarAggregationSettingItem>>
  isAllPagesLinked?: Maybe<Scalars['Boolean']['output']>
}

export type ProgressBarAggregationSettingItem = AggregationSettingItem & {
  __typename?: 'ProgressBarAggregationSettingItem'
  dataSources?: Maybe<Array<Scalars['ID']['output']>>
  endVisibleTime?: Maybe<Scalars['DateTime']['output']>
  groupId: Scalars['ID']['output']
  groupName?: Maybe<Scalars['String']['output']>
  hideWhenMatchedGivingActive?: Maybe<Scalars['Boolean']['output']>
  isAllPagesLinked?: Maybe<Scalars['Boolean']['output']>
  isGoalHidden?: Maybe<Scalars['Boolean']['output']>
  offset?: Maybe<Scalars['Float']['output']>
  pageBucketIds?: Maybe<Array<Scalars['ID']['output']>>
  pageIds: Array<Scalars['ID']['output']>
  progressBarGoals?: Maybe<Array<ProgressBarGoal>>
  startVisibleTime?: Maybe<Scalars['DateTime']['output']>
}

export type ProgressBarAggregationSettingItemInput = {
  dataSources?: InputMaybe<Array<Scalars['ID']['input']>>
  endVisibleTime?: InputMaybe<Scalars['DateTime']['input']>
  groupId: Scalars['ID']['input']
  groupName?: InputMaybe<Scalars['String']['input']>
  hideWhenMatchedGivingActive?: InputMaybe<Scalars['Boolean']['input']>
  isAllPagesLinked?: InputMaybe<Scalars['Boolean']['input']>
  isGoalHidden?: InputMaybe<Scalars['Boolean']['input']>
  offset?: InputMaybe<Scalars['Float']['input']>
  pageBucketIds?: InputMaybe<Array<Scalars['ID']['input']>>
  pageIds: Array<Scalars['ID']['input']>
  progressBarGoals?: InputMaybe<Array<ProgressBarGoalInput>>
  startVisibleTime?: InputMaybe<Scalars['DateTime']['input']>
}

export type ProgressBarAmount = {
  __typename?: 'ProgressBarAmount'
  amount?: Maybe<Scalars['Float']['output']>
}

export type ProgressBarGoal = {
  __typename?: 'ProgressBarGoal'
  goal: Scalars['Float']['output']
  index: Scalars['Int']['output']
}

export type ProgressBarGoalInput = {
  goal: Scalars['Float']['input']
  index: Scalars['Int']['input']
}

export type ProgressBarInput = {
  bonusGoals?: InputMaybe<Array<BonusGoalInput>>
  componentId: Scalars['ID']['input']
  end?: InputMaybe<Scalars['DateTime']['input']>
  goals?: InputMaybe<Array<Scalars['Int']['input']>>
  hideBeforeStart?: InputMaybe<Scalars['Boolean']['input']>
  hideOnEnd?: InputMaybe<Scalars['Boolean']['input']>
  hideOnGoalReached?: InputMaybe<Scalars['Boolean']['input']>
  hideWhenMatchedGivingActive?: InputMaybe<Scalars['Boolean']['input']>
  isAllPagesLinked?: InputMaybe<Scalars['Boolean']['input']>
  linkedPageIds?: InputMaybe<Array<Scalars['ID']['input']>>
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  offset?: InputMaybe<Scalars['Float']['input']>
  start?: InputMaybe<Scalars['DateTime']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  text?: InputMaybe<TextInput>
  title?: InputMaybe<Scalars['String']['input']>
  type: ComponentTypeInput
}

export type ProgressImage = Component & {
  __typename?: 'ProgressImage'
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type ProgressImageInput = {
  componentId: Scalars['ID']['input']
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  subComponents: Scalars['JSON']['input']
  type: ComponentTypeInput
}

export type ProgressImageSubComponents = {
  __typename?: 'ProgressImageSubComponents'
  backgroundImage?: Maybe<Scalars['ID']['output']>
  foregroundText?: Maybe<Scalars['ID']['output']>
  image: Scalars['ID']['output']
}

export type PublishPageInput = {
  campaignId: Scalars['ID']['input']
  ids: Array<Scalars['ID']['input']>
}

export type Query = {
  __typename?: 'Query'
  aggregatedGivings?: Maybe<AggregatedGivings>
  aggregationSettings: AggregationSettings
  analyticsIntegrationSettings: AnalyticsIntegrationSettings
  branding: Branding
  brandings: Array<Branding>
  campaign: Campaign
  campaignAggregateGivingStats: GetCampaignPerformanceStatsQueryResult
  campaignAmountsByDate: Array<CampaignDonationByDateStat>
  campaignAnalyticsSettings: CampaignAnalyticsSettings
  campaignAssets: Array<CampaignAsset>
  campaignDomain: CampaignDomain
  campaignLandingPageId?: Maybe<Scalars['ID']['output']>
  campaignMatchedGivingSettings: Array<CampaignMatchedGivingSetting>
  campaignPageDonationAmounts: Array<CampaignPageDonationAmountStat>
  campaignPageMetadata?: Maybe<PageMetadata>
  campaignPaymentSettings: CampaignPaymentSettings
  campaignPerformance: GetCampaignPerformanceStatsQueryResult
  campaignSettings: CampaignSettings
  campaignTopDonationAmounts: Array<CampaignDonorAmountStat>
  campaignTriggers?: Maybe<CampaignTrigger>
  campaignUtmTagDonationAmounts: Array<CampaignUtmTagDonationAmountStat>
  campaigns: Array<Campaign>
  campaignsOverview: Array<CampaignOverview>
  capturePayment: Scalars['Boolean']['output']
  charities: Array<Charity>
  charity: Charity
  charityDetail: CharityDetail
  charityDonorPortalSettings?: Maybe<CharityDonorPortalSettings>
  charityMergeTags: Array<MergeFieldSetting>
  charityMetadata?: Maybe<CharityMetadata>
  charityPageRedirectionSetting: Array<CharityPageRedirectionSetting>
  charityPaymentSettings: CharityPaymentSettings
  charityProfileCategories: Array<ProfileCategory>
  charityStripeCustomProviderSettings: CharityPaymentSettings
  charityTaxSummaryStatus: CharityTaxSummaryStatus
  charityTaxSummaryTotalEmailCount: Scalars['Int']['output']
  charityTemplateLayout: Page
  charityTemplates: Array<CharityTemplateDetail>
  charityUserRoles: Array<Role>
  charityUsers?: Maybe<CharityUserWithPagination>
  claims: Array<CharityClaim>
  comments: CommentsQueryResult
  customFieldSettings: Array<CustomFieldSetting>
  donorGivings: DonorGivingsQueryResult
  donorPortalSettings: DonorPortalSlugResponse
  donorProfile: DonorProfile
  donorSubscriptions: DonorSubscriptionsQueryResult
  featureFlag: Scalars['JSON']['output']
  formData: FormDataQueryResult
  fullMatchedGivingProgress: MatchedGivingProgressResult
  givings: GivingsQueryResult
  leaderboard: Array<ProfileData>
  matchedGivingProgress: MatchedGivingProgressResult
  matchedGivingRecords: MatchedGivingQueryResult
  mergeFields: Array<MergeField>
  page: Page
  pageBuckets: Array<PageBucketDetail>
  pageLayout: Page
  pageMetadata?: Maybe<Metadata>
  pages: Array<PageDetail>
  pagesWithPageTypes: Array<PageDetail>
  paymentSettings?: Maybe<PaymentSettings>
  paymentTransactions: PaymentTransactionQueryResult
  payout: Payout
  payoutTransactions: Array<PaymentTransaction>
  payouts: PayoutQueryResult
  previewLayout: PreviewQueryResult
  profileCategories: Array<ProfileCategory>
  profileData: ProfileData
  profiles: Array<ProfileData>
  progressBarAmount?: Maybe<ProgressBarAmount>
  purl: Scalars['JSON']['output']
  purlParams: Scalars['JSON']['output']
  salesforceContact?: Maybe<SalesforceContact>
  searchBySlug: SlugResponse
  sectionTemplates: Scalars['JSON']['output']
  subscriptions: SubscriptionsQueryResult
  templatePage?: Maybe<Page>
  thankYouPage: Page
  thankYouPageIdFromId: Scalars['ID']['output']
  thankYouPageLayout: Page
  thankYouPageReferences: Array<Scalars['ID']['output']>
  thankYouPages: Array<PageDetail>
  unpaidBalance: Balance
  unpaidTransactions: Array<PaymentTransaction>
  validateToken: Scalars['Boolean']['output']
}

export type QueryAggregatedGivingsArgs = {
  input: AggregatedGivingsInput
}

export type QueryAggregationSettingsArgs = {
  campaignId: Scalars['ID']['input']
  pageBucketId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryBrandingArgs = {
  id: Scalars['ID']['input']
}

export type QueryCampaignArgs = {
  id: Scalars['ID']['input']
}

export type QueryCampaignAggregateGivingStatsArgs = {
  campaignId: Scalars['ID']['input']
  endDate: Scalars['DateTime']['input']
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  startDate: Scalars['DateTime']['input']
  timezoneOffsetInMinutes: Scalars['Int']['input']
}

export type QueryCampaignAmountsByDateArgs = {
  campaignId: Scalars['ID']['input']
  endDate: Scalars['DateTime']['input']
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  startDate: Scalars['DateTime']['input']
  timezoneOffsetInMinutes: Scalars['Int']['input']
}

export type QueryCampaignAnalyticsSettingsArgs = {
  campaignId: Scalars['ID']['input']
}

export type QueryCampaignAssetsArgs = {
  campaignId: Scalars['ID']['input']
  pagination: PaginationQuery
}

export type QueryCampaignDomainArgs = {
  campaignId: Scalars['ID']['input']
}

export type QueryCampaignLandingPageIdArgs = {
  campaignId: Scalars['ID']['input']
  isLiveMode: Scalars['Boolean']['input']
  pageBucketId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryCampaignMatchedGivingSettingsArgs = {
  campaignId: Scalars['ID']['input']
}

export type QueryCampaignPageDonationAmountsArgs = {
  campaignId: Scalars['ID']['input']
  endDate: Scalars['DateTime']['input']
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  startDate: Scalars['DateTime']['input']
  timezoneOffsetInMinutes: Scalars['Int']['input']
}

export type QueryCampaignPageMetadataArgs = {
  campaignId: Scalars['ID']['input']
  pageId: Scalars['ID']['input']
}

export type QueryCampaignPaymentSettingsArgs = {
  campaignId: Scalars['ID']['input']
}

export type QueryCampaignPerformanceArgs = {
  campaignId: Scalars['ID']['input']
  endDate: Scalars['DateTime']['input']
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  startDate: Scalars['DateTime']['input']
  timezoneOffsetInMinutes: Scalars['Int']['input']
}

export type QueryCampaignSettingsArgs = {
  campaignId: Scalars['ID']['input']
}

export type QueryCampaignTopDonationAmountsArgs = {
  campaignId: Scalars['ID']['input']
  endDate: Scalars['DateTime']['input']
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  startDate: Scalars['DateTime']['input']
  timezoneOffsetInMinutes: Scalars['Int']['input']
}

export type QueryCampaignTriggersArgs = {
  campaignId: Scalars['ID']['input']
  pageBucketId: Scalars['ID']['input']
}

export type QueryCampaignUtmTagDonationAmountsArgs = {
  campaignId: Scalars['ID']['input']
  endDate: Scalars['DateTime']['input']
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  startDate: Scalars['DateTime']['input']
  timezoneOffsetInMinutes: Scalars['Int']['input']
}

export type QueryCampaignsArgs = {
  pagination: PaginationQuery
}

export type QueryCampaignsOverviewArgs = {
  campaignIds: Array<Scalars['ID']['input']>
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryCapturePaymentArgs = {
  orderId: Scalars['String']['input']
}

export type QueryCharityMetadataArgs = {
  charityId: Scalars['ID']['input']
}

export type QueryCharityTaxSummaryStatusArgs = {
  financialYear: Scalars['Int']['input']
  isLiveMode: Scalars['Boolean']['input']
}

export type QueryCharityTaxSummaryTotalEmailCountArgs = {
  financialYear: Scalars['Int']['input']
  isLiveMode: Scalars['Boolean']['input']
  taxSummarySettingType: CharityTaxSummaryMessageType
}

export type QueryCharityTemplateLayoutArgs = {
  pageId: Scalars['ID']['input']
}

export type QueryCharityTemplatesArgs = {
  pageType: PageType
  type: CharityTemplateType
}

export type QueryCharityUsersArgs = {
  pagination: PaginationQuery
}

export type QueryClaimsArgs = {
  pagination?: InputMaybe<PaginationQuery>
}

export type QueryCommentsArgs = {
  query: CommentsQueryInput
}

export type QueryDonorGivingsArgs = {
  input: GivingsQueryInput
}

export type QueryDonorPortalSettingsArgs = {
  url: Scalars['String']['input']
}

export type QueryDonorSubscriptionsArgs = {
  input: GivingsQueryInput
  token: Scalars['String']['input']
}

export type QueryFeatureFlagArgs = {
  flags: Array<Scalars['String']['input']>
}

export type QueryFormDataArgs = {
  formId: Scalars['ID']['input']
}

export type QueryFullMatchedGivingProgressArgs = {
  campaignId: Scalars['ID']['input']
  isLiveMode: Scalars['Boolean']['input']
  matchedGivingId: Scalars['ID']['input']
}

export type QueryGivingsArgs = {
  input: GivingsQueryInput
}

export type QueryLeaderboardArgs = {
  campaignId: Scalars['ID']['input']
  charityId: Scalars['ID']['input']
  isApprovedOnly?: InputMaybe<Scalars['Boolean']['input']>
  isLiveMode: Scalars['Boolean']['input']
  orderBy: ProfileQueryOrderType
}

export type QueryMatchedGivingProgressArgs = {
  campaignId: Scalars['ID']['input']
  isLiveMode: Scalars['Boolean']['input']
  matchedGivingId: Scalars['ID']['input']
}

export type QueryMatchedGivingRecordsArgs = {
  mode: Mode
  pageNumber: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
}

export type QueryMergeFieldsArgs = {
  name?: InputMaybe<Scalars['String']['input']>
}

export type QueryPageArgs = {
  campaignId?: InputMaybe<Scalars['ID']['input']>
  id: Scalars['ID']['input']
  profileId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryPageBucketsArgs = {
  campaignId: Scalars['ID']['input']
}

export type QueryPageLayoutArgs = {
  pageId: Scalars['ID']['input']
  pageType?: InputMaybe<PageType>
}

export type QueryPageMetadataArgs = {
  campaignId: Scalars['ID']['input']
  charityId: Scalars['ID']['input']
  pageId: Scalars['ID']['input']
}

export type QueryPagesArgs = {
  campaignId: Scalars['ID']['input']
  pageTypes: Array<PageType>
}

export type QueryPagesWithPageTypesArgs = {
  campaignId: Scalars['ID']['input']
  pageTypes: Array<PageType>
}

export type QueryPaymentSettingsArgs = {
  campaignId: Scalars['ID']['input']
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryPaymentTransactionsArgs = {
  endDate: Scalars['String']['input']
  mode: Mode
  pageNumber: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
  paymentProviderId?: InputMaybe<Scalars['ID']['input']>
  startDate: Scalars['String']['input']
}

export type QueryPayoutArgs = {
  payoutId: Scalars['ID']['input']
}

export type QueryPayoutTransactionsArgs = {
  payoutId: Scalars['ID']['input']
}

export type QueryPayoutsArgs = {
  mode: Mode
  pageNumber: Scalars['Int']['input']
  pageSize: Scalars['Int']['input']
  paymentProviderId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryPreviewLayoutArgs = {
  previewId: Scalars['ID']['input']
}

export type QueryProfileCategoriesArgs = {
  campaignId: Scalars['ID']['input']
}

export type QueryProfileDataArgs = {
  campaignId: Scalars['ID']['input']
  charityId: Scalars['ID']['input']
  profileId: Scalars['ID']['input']
}

export type QueryProfilesArgs = {
  campaignId: Scalars['ID']['input']
  isApprovedOnly?: InputMaybe<Scalars['Boolean']['input']>
  isLiveMode: Scalars['Boolean']['input']
  orderBy: ProfileQueryOrderType
}

export type QueryProgressBarAmountArgs = {
  campaignId: Scalars['ID']['input']
  isAllPagesLinked: Scalars['Boolean']['input']
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  pageIds?: InputMaybe<Array<Scalars['ID']['input']>>
  profileId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryPurlArgs = {
  campaignId: Scalars['ID']['input']
  charityId: Scalars['ID']['input']
  id?: InputMaybe<Scalars['String']['input']>
  params?: InputMaybe<Scalars['String']['input']>
}

export type QueryPurlParamsArgs = {
  campaignId: Scalars['ID']['input']
  charityId: Scalars['ID']['input']
  id?: InputMaybe<Scalars['String']['input']>
  params?: InputMaybe<Scalars['String']['input']>
}

export type QuerySalesforceContactArgs = {
  charityId: Scalars['ID']['input']
  contactId: Scalars['String']['input']
  donorId: Scalars['String']['input']
}

export type QuerySearchBySlugArgs = {
  isLiveMode: Scalars['Boolean']['input']
  url: Scalars['String']['input']
}

export type QuerySectionTemplatesArgs = {
  pageType: PageType
}

export type QuerySubscriptionsArgs = {
  input: SubscriptionsQueryInput
}

export type QueryTemplatePageArgs = {
  templateId: Scalars['ID']['input']
  templateType: TemplateType
}

export type QueryThankYouPageArgs = {
  pageId: Scalars['ID']['input']
}

export type QueryThankYouPageIdFromIdArgs = {
  campaignId: Scalars['ID']['input']
  pageId: Scalars['ID']['input']
}

export type QueryThankYouPageLayoutArgs = {
  pageId: Scalars['ID']['input']
}

export type QueryThankYouPageReferencesArgs = {
  campaignId: Scalars['ID']['input']
  pageId: Scalars['ID']['input']
}

export type QueryThankYouPagesArgs = {
  campaignId: Scalars['ID']['input']
}

export type QueryUnpaidBalanceArgs = {
  mode: Mode
  paymentProviderId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryUnpaidTransactionsArgs = {
  mode: Mode
  paymentProviderId?: InputMaybe<Scalars['ID']['input']>
}

export type QueryValidateTokenArgs = {
  charityId: Scalars['ID']['input']
  profileId?: InputMaybe<Scalars['ID']['input']>
  token: Scalars['String']['input']
}

export type QuickPayValuesInput = {
  address?: InputMaybe<AddressInput>
  charityId: Scalars['ID']['input']
  customFields?: InputMaybe<Array<FormCustomFieldInput>>
  firstName: Scalars['String']['input']
  fullAddress?: InputMaybe<Scalars['String']['input']>
  lastName: Scalars['String']['input']
  organisation?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  transactionId: Scalars['ID']['input']
}

export type RgbColor = {
  __typename?: 'RGBColor'
  a?: Maybe<Scalars['Int']['output']>
  b: Scalars['Int']['output']
  g: Scalars['Int']['output']
  r: Scalars['Int']['output']
}

export type RgbColorInput = {
  a?: InputMaybe<Scalars['Int']['input']>
  b: Scalars['Int']['input']
  g: Scalars['Int']['input']
  r: Scalars['Int']['input']
}

export type RaiserEdgeIntegrationSetting = {
  __typename?: 'RaiserEdgeIntegrationSetting'
  callbackUrl: Scalars['String']['output']
  clientId: Scalars['String']['output']
  primarySubscriptionKey: Scalars['String']['output']
  secondarySubscriptionKey: Scalars['String']['output']
  settingId?: Maybe<Scalars['ID']['output']>
}

export type RaiserEdgeIntegrationSettingInput = {
  callbackUrl: Scalars['String']['input']
  clientId: Scalars['String']['input']
  clientSecret: Scalars['String']['input']
  primarySubscriptionKey: Scalars['String']['input']
  secondarySubscriptionKey: Scalars['String']['input']
}

export type ReceiptOptionSetting = {
  __typename?: 'ReceiptOptionSetting'
  givingReceiptOption?: Maybe<GivingReceiptOptionSetting>
  sendFundraiserWelcomeEmail?: Maybe<Scalars['Boolean']['output']>
  sendPdfReceipt?: Maybe<Scalars['Boolean']['output']>
  subscriptionReceiptOption?: Maybe<SubscriptionReceiptOptionSetting>
}

export type RefundTransactionDetail = {
  __typename?: 'RefundTransactionDetail'
  donationFormAmount: Scalars['Float']['output']
  transactionAmount: Scalars['Float']['output']
}

export type RegisterDonorEmailResponse = {
  __typename?: 'RegisterDonorEmailResponse'
  token: Scalars['String']['output']
}

export type RegisterEmailResponse = {
  __typename?: 'RegisterEmailResponse'
  hasProfileInCampaign: Scalars['Boolean']['output']
  isExistingUser: Scalars['Boolean']['output']
  token: Scalars['String']['output']
}

export type RegisterForm = Component & {
  __typename?: 'RegisterForm'
  extraFields?: Maybe<Array<ExtraField>>
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type RegisterFormInput = {
  componentId: Scalars['ID']['input']
  extraFields?: InputMaybe<Array<ExtraFieldInput>>
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  subComponents: Scalars['JSON']['input']
  type: ComponentTypeInput
}

export type RegisterFormSubcomponents = {
  __typename?: 'RegisterFormSubcomponents'
  title?: Maybe<Scalars['ID']['output']>
}

export type RegisterProfileInput = {
  campaignId: Scalars['ID']['input']
  charityId: Scalars['ID']['input']
  description?: InputMaybe<Scalars['String']['input']>
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  goal?: InputMaybe<Scalars['Int']['input']>
  isGivingNotificationEnabled: Scalars['Boolean']['input']
  lastName: Scalars['String']['input']
  profileCategoryId: Scalars['ID']['input']
  profileName: Scalars['String']['input']
}

export type RegisterProfileResult = {
  __typename?: 'RegisterProfileResult'
  profileId: Scalars['ID']['output']
  redirectUrl: Scalars['String']['output']
}

export type ResendReceiptInput = {
  email: Scalars['String']['input']
  firstName?: InputMaybe<Scalars['String']['input']>
  givingId: Scalars['ID']['input']
  lastName?: InputMaybe<Scalars['String']['input']>
}

export type ResumeSubscriptionInput = {
  externalSubscriptionId: Scalars['String']['input']
  paymentSubscriptionId: Scalars['ID']['input']
}

export type Role = {
  __typename?: 'Role'
  roleId: Scalars['ID']['output']
  roleName: Scalars['String']['output']
}

export enum Roles {
  Agency = 'Agency',
  CharityAdmin = 'CharityAdmin',
  CharityUser = 'CharityUser',
  GiveEasyAdmin = 'GiveEasyAdmin',
}

export type Row = Component & {
  __typename?: 'Row'
  components: Array<PageComponent>
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type RowInput = {
  componentId: Scalars['ID']['input']
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  type: ComponentTypeInput
}

export type SalesforceContact = {
  __typename?: 'SalesforceContact'
  email?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  lastName?: Maybe<Scalars['String']['output']>
}

export type SaveDetailsInput = {
  id: Scalars['ID']['input']
  pageName?: InputMaybe<Scalars['String']['input']>
  pageSlug?: InputMaybe<Scalars['String']['input']>
  pageType: PageType
  screenshotImageUrl?: InputMaybe<Scalars['String']['input']>
}

export type SaveDraftInput = {
  charityPageTemplateId?: InputMaybe<Scalars['ID']['input']>
  charityPageTemplateVersion?: InputMaybe<Scalars['Int']['input']>
  htmlLayout?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  name: Scalars['String']['input']
  pageLayout: PageLayoutInput
  pageName?: InputMaybe<Scalars['String']['input']>
  pageType: PageType
  screenshotImageUrl?: InputMaybe<Scalars['String']['input']>
}

export type SavePageMetadataInput = {
  campaignId: Scalars['ID']['input']
  ogDescription?: InputMaybe<Scalars['String']['input']>
  ogImage?: InputMaybe<Scalars['String']['input']>
  ogTitle?: InputMaybe<Scalars['String']['input']>
  pageId: Scalars['ID']['input']
}

export type SelectCharityInput = {
  auth0Id: Scalars['String']['input']
  charityId: Scalars['String']['input']
}

export type SendCharityTaxSummaryInput = {
  financialYear: Scalars['Int']['input']
  isLiveMode: Scalars['Boolean']['input']
  taxSummarySetting: CharityTaxSummaryMessageType
}

export type SendTestReceiptInput = {
  campaignId: Scalars['ID']['input']
  receiptPageId: Scalars['ID']['input']
  to: Scalars['String']['input']
}

export type SetCampaignEmailSettingInput = {
  campaignId: Scalars['ID']['input']
  givingReceiptOption?: InputMaybe<GivingReceiptOptionSetting>
  receiptSubjects?: InputMaybe<Array<SetEmailSettingSubjectItemInput>>
  sendPdfReceipt?: InputMaybe<Scalars['Boolean']['input']>
  subscriptionReceiptOption?: InputMaybe<SubscriptionReceiptOptionSetting>
}

export type SetCampaignPaymentProviderSettingsInput = {
  campaignId: Scalars['ID']['input']
  paymentProviderId: Scalars['String']['input']
}

export type SetCampaignPaymentProviderSettingsResponse = {
  __typename?: 'SetCampaignPaymentProviderSettingsResponse'
  campaignId: Scalars['ID']['output']
}

export type SetCampaignPlatformFeeTypeInput = {
  campaignId: Scalars['ID']['input']
  platformFeeType: PlatformFeeType
}

export type SetDefaultCampaignPageInput = {
  campaignId: Scalars['ID']['input']
  pageId: Scalars['ID']['input']
}

export type SetEmailReceiptOptionsInput = {
  campaignId: Scalars['ID']['input']
  givingReceiptOption: GivingReceiptOptionSetting
  subscriptionReceiptOption: SubscriptionReceiptOptionSetting
}

export type SetEmailSettingItemInput = {
  campaignId: Scalars['ID']['input']
  receiptPageId: Scalars['ID']['input']
  subject?: InputMaybe<Scalars['String']['input']>
}

export type SetEmailSettingSubjectItemInput = {
  receiptPageId: Scalars['ID']['input']
  subject?: InputMaybe<Scalars['String']['input']>
}

export type SetFundraiserRegistrationNotificationsForProfileInput = {
  campaignId: Scalars['ID']['input']
  emailValues?: InputMaybe<Array<FundraiserRegistrationEmailInput>>
  isEnabled: Scalars['Boolean']['input']
}

export type SetPageReferencesInput = {
  campaignId: Scalars['ID']['input']
  pageIdsForReceipt: Array<Scalars['ID']['input']>
  pageIdsForThankYou: Array<Scalars['ID']['input']>
  receiptPageId: Scalars['ID']['input']
  thankYouPageId: Scalars['ID']['input']
}

export type SetPaymentProviderSettingsResponse = {
  __typename?: 'SetPaymentProviderSettingsResponse'
  label: Scalars['String']['output']
}

export type SetReceiptPageReferencesInput = {
  campaignId: Scalars['ID']['input']
  pageIds: Array<Scalars['ID']['input']>
  receiptPageId: Scalars['ID']['input']
}

export type SetThankYouPageReferencesInput = {
  campaignId: Scalars['ID']['input']
  pageIds: Array<Scalars['ID']['input']>
  thankYouPageId: Scalars['ID']['input']
}

export type SlugResponse = {
  __typename?: 'SlugResponse'
  campaignId: Scalars['ID']['output']
  campaignSettings?: Maybe<CampaignSettings>
  charityId: Scalars['ID']['output']
  layout: Page
  pageBucketId?: Maybe<Scalars['ID']['output']>
  pageId?: Maybe<Scalars['ID']['output']>
  profileData?: Maybe<ProfileData>
  profileId?: Maybe<Scalars['ID']['output']>
  redirectUrl?: Maybe<Scalars['String']['output']>
}

export type SocialShare = Component & {
  __typename?: 'SocialShare'
  hasEmail?: Maybe<Scalars['Boolean']['output']>
  hasFacebook?: Maybe<Scalars['Boolean']['output']>
  hasLink?: Maybe<Scalars['Boolean']['output']>
  hasLinkedIn?: Maybe<Scalars['Boolean']['output']>
  hasTwitter?: Maybe<Scalars['Boolean']['output']>
  hasWhatsApp?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type SocialShareInput = {
  componentId: Scalars['ID']['input']
  hasEmail?: InputMaybe<Scalars['Boolean']['input']>
  hasFacebook?: InputMaybe<Scalars['Boolean']['input']>
  hasLink?: InputMaybe<Scalars['Boolean']['input']>
  hasLinkedIn?: InputMaybe<Scalars['Boolean']['input']>
  hasTwitter?: InputMaybe<Scalars['Boolean']['input']>
  hasWhatsApp?: InputMaybe<Scalars['Boolean']['input']>
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  type: ComponentTypeInput
}

export type StripePaymentSettings = {
  __typename?: 'StripePaymentSettings'
  connectAccountId?: Maybe<Scalars['String']['output']>
  isConnectAccountLive?: Maybe<Scalars['Boolean']['output']>
  paymentChargeType?: Maybe<PaymentChargeType>
  paymentProviderType?: Maybe<PaymentProviderType>
  platformAccountId?: Maybe<Scalars['String']['output']>
  publishableKey?: Maybe<Scalars['String']['output']>
}

export type StripeSubscriptionDonorPortalLink = {
  __typename?: 'StripeSubscriptionDonorPortalLink'
  url: Scalars['String']['output']
}

export type StripeSubscriptionDonorPortalLinkInput = {
  externalSubscriptionId: Scalars['String']['input']
  paymentSubscriptionId: Scalars['ID']['input']
}

export type StripeTransactionExternalData = {
  __typename?: 'StripeTransactionExternalData'
  connectId: Scalars['String']['output']
  paymentIntentId: Scalars['String']['output']
}

export type SubmitFormValuesInput = {
  charityId: Scalars['ID']['input']
  formId: Scalars['ID']['input']
  formValues?: InputMaybe<Array<FormCustomFieldInput>>
}

export type SubmitPostDonationFormValuesInput = {
  address?: InputMaybe<AddressInput>
  charityId: Scalars['ID']['input']
  customFields?: InputMaybe<Array<FormCustomFieldInput>>
  mobile?: InputMaybe<Scalars['String']['input']>
  paymentSubscriptionId?: InputMaybe<Scalars['ID']['input']>
  transactionId?: InputMaybe<Scalars['ID']['input']>
}

export type SubscriptionInvoice = {
  __typename?: 'SubscriptionInvoice'
  invoiceDate: Scalars['DateTime']['output']
  invoiceStatus: SubscriptionInvoiceStatus
}

export enum SubscriptionInvoiceStatus {
  Draft = 'Draft',
  NeedsEnrichment = 'NeedsEnrichment',
  Open = 'Open',
  Paid = 'Paid',
  PartiallyRefunded = 'PartiallyRefunded',
  Refunded = 'Refunded',
  Uncollectible = 'Uncollectible',
  Void = 'Void',
}

export enum SubscriptionReceiptOptionSetting {
  Always = 'Always',
  InitialOnly = 'InitialOnly',
  None = 'None',
}

export type SubscriptionRecord = {
  __typename?: 'SubscriptionRecord'
  campaign: Scalars['String']['output']
  currencyCode: Scalars['String']['output']
  donationFormAmount: Scalars['Float']['output']
  donationFrequencyType: GivingDonationFrequency
  email: Scalars['String']['output']
  endAt?: Maybe<Scalars['DateTime']['output']>
  externalSubscriptionId: Scalars['String']['output']
  firstName?: Maybe<Scalars['String']['output']>
  lastGiving?: Maybe<SubscriptionRegularGiving>
  lastInvoice?: Maybe<SubscriptionInvoice>
  lastName?: Maybe<Scalars['String']['output']>
  nextPaymentDate?: Maybe<Scalars['DateTime']['output']>
  page: Scalars['String']['output']
  paymentMethodType: PaymentMethodType
  resumeAt?: Maybe<Scalars['DateTime']['output']>
  scheduledUpdate?: Maybe<SubscriptionScheduledUpdate>
  startAt: Scalars['DateTime']['output']
  status: SubscriptionStatus
  subscriptionId: Scalars['ID']['output']
  subscriptionStartAt: Scalars['DateTime']['output']
  totalGivingTransactionAmount: Scalars['Float']['output']
  transactionAmount: Scalars['Float']['output']
}

export type SubscriptionRegularGiving = {
  __typename?: 'SubscriptionRegularGiving'
  givingDate: Scalars['DateTime']['output']
  givingStatus: GivingStatus
}

export type SubscriptionScheduledUpdate = {
  __typename?: 'SubscriptionScheduledUpdate'
  amount?: Maybe<Scalars['Float']['output']>
  donationFrequencyType?: Maybe<GivingDonationFrequency>
  externalSubscriptionScheduleId: Scalars['String']['output']
  startAt?: Maybe<Scalars['DateTime']['output']>
  subscriptionScheduleId: Scalars['ID']['output']
}

export enum SubscriptionStatus {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Incomplete = 'Incomplete',
  IncompleteExpired = 'IncompleteExpired',
  PastDue = 'PastDue',
  Paused = 'Paused',
  Trialing = 'Trialing',
  Unpaid = 'Unpaid',
}

export type SubscriptionsFilterInput = {
  donationFrequency?: InputMaybe<GivingDonationFrequency>
  mode?: InputMaybe<Mode>
  search?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<SubscriptionStatus>
}

export type SubscriptionsQueryInput = {
  endDate?: InputMaybe<Scalars['String']['input']>
  filter?: InputMaybe<SubscriptionsFilterInput>
  pageNumber: Scalars['Int']['input']
  pageSize?: InputMaybe<Scalars['Int']['input']>
  startDate?: InputMaybe<Scalars['String']['input']>
}

export type SubscriptionsQueryResult = {
  __typename?: 'SubscriptionsQueryResult'
  items: Array<SubscriptionRecord>
  totalRecords: Scalars['Int']['output']
}

export type Tax = {
  __typename?: 'Tax'
  countryCodeIso2: Scalars['String']['output']
  label?: Maybe<Scalars['String']['output']>
  percentage: Scalars['Float']['output']
}

export enum TemplateType {
  Charity = 'Charity',
  Fed = 'FED',
  GiveEasy = 'GiveEasy',
}

export type Text = Component & {
  __typename?: 'Text'
  htmlText?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  textValue: Scalars['String']['output']
  type: ComponentType
}

export type TextInput = {
  componentId: Scalars['ID']['input']
  htmlText?: InputMaybe<Scalars['String']['input']>
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  textValue: Scalars['String']['input']
  type: ComponentTypeInput
}

export type TransactionExternalData = {
  __typename?: 'TransactionExternalData'
  offlineData?: Maybe<OfflineTransactionExternalData>
  payPalData?: Maybe<PayPalTransactionExternalData>
  paymentServiceTransactionId: Scalars['ID']['output']
  stripeData?: Maybe<StripeTransactionExternalData>
}

export type TransactionFees = {
  __typename?: 'TransactionFees'
  internalManagedAdminFee?: Maybe<Scalars['Float']['output']>
  paymentGatewayFee?: Maybe<Scalars['Float']['output']>
  platformFee?: Maybe<Scalars['Float']['output']>
  totalFee: Scalars['Float']['output']
  totalTax?: Maybe<Scalars['Float']['output']>
}

export enum TriggerType {
  Amount = 'Amount',
  DateTime = 'DateTime',
}

export type UpdateBrandingInput = {
  brandingId: Scalars['ID']['input']
  saveAsDefault?: InputMaybe<Scalars['Boolean']['input']>
  value: Scalars['String']['input']
}

export type UpdateBrandingResponse = {
  __typename?: 'UpdateBrandingResponse'
  brandingId: Scalars['ID']['output']
}

export type UpdateGa4IntegrationSettingInput = {
  name?: InputMaybe<Scalars['String']['input']>
  settingId: Scalars['String']['input']
}

export type UpdateGtmIntegrationSettingInput = {
  name?: InputMaybe<Scalars['String']['input']>
  settingId: Scalars['String']['input']
}

export type UpdatePaymentDetailsInput = {
  address?: InputMaybe<AddressInput>
  customFields?: InputMaybe<Array<FormCustomFieldInput>>
  donationFormAmount?: InputMaybe<Scalars['Float']['input']>
  donorPaysAmount?: InputMaybe<Scalars['Float']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  fullAddress?: InputMaybe<Scalars['String']['input']>
  givingFrequency?: InputMaybe<DonationFrequency>
  isDonorChooseToPayFee?: InputMaybe<Scalars['Boolean']['input']>
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  mobile?: InputMaybe<Scalars['String']['input']>
  organisation?: InputMaybe<Scalars['String']['input']>
  paymentCardType?: InputMaybe<Scalars['String']['input']>
  paymentIntentId?: InputMaybe<Scalars['ID']['input']>
  paymentMethodId?: InputMaybe<Scalars['String']['input']>
  paymentMethodType?: InputMaybe<PaymentMethodType>
  subscriptionId?: InputMaybe<Scalars['ID']['input']>
}

export type UpdatePaymentInput = {
  campaignId: Scalars['ID']['input']
  charityId: Scalars['ID']['input']
  customFields?: InputMaybe<Array<FormCustomFieldInput>>
  donationFormAmount?: InputMaybe<Scalars['Float']['input']>
  donorPaysAmount?: InputMaybe<Scalars['Float']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  givingFrequency?: InputMaybe<DonationFrequency>
  isDonorChooseToPayFee?: InputMaybe<Scalars['Boolean']['input']>
  isLiveMode?: InputMaybe<Scalars['Boolean']['input']>
  pageId: Scalars['ID']['input']
  paymentIntentId?: InputMaybe<Scalars['ID']['input']>
  paymentMethodType?: InputMaybe<PaymentMethodType>
  subscriptionId?: InputMaybe<Scalars['ID']['input']>
}

export type UpdatePaymentIntentResponse = {
  __typename?: 'UpdatePaymentIntentResponse'
  clientSecret?: Maybe<Scalars['String']['output']>
  paymentIntentId?: Maybe<Scalars['ID']['output']>
}

export enum UpdatePaymentMethodPermission {
  Anytime = 'Anytime',
  None = 'None',
  WhenPaymentFailed = 'WhenPaymentFailed',
}

export type UpdatePixelConversionsApiIntegrationSettingInput = {
  name?: InputMaybe<Scalars['String']['input']>
  settingId: Scalars['String']['input']
  testEventCode?: InputMaybe<Scalars['String']['input']>
}

export type UpdateProfileInput = {
  campaignId: Scalars['ID']['input']
  description?: InputMaybe<Scalars['String']['input']>
  goal?: InputMaybe<Scalars['Int']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  isApproved?: InputMaybe<Scalars['Boolean']['input']>
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>
  isGivingNotificationEnabled?: InputMaybe<Scalars['Boolean']['input']>
  logoUrl?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  profileId: Scalars['ID']['input']
  slug?: InputMaybe<Scalars['String']['input']>
}

export type UpdateSubscriptionAdminInput = {
  donationDetails?: InputMaybe<UpdateSubscriptionDonationDetailAdminInput>
  externalSubscriptionId: Scalars['String']['input']
  paymentSubscriptionId: Scalars['ID']['input']
  personalDetails?: InputMaybe<UpdateSubscriptionPersonalDetailAdminInput>
}

export type UpdateSubscriptionAdminResponse = {
  __typename?: 'UpdateSubscriptionAdminResponse'
  externalSubscriptionScheduleId?: Maybe<Scalars['String']['output']>
  paymentSubscriptionScheduleId?: Maybe<Scalars['ID']['output']>
}

export type UpdateSubscriptionDonationDetailAdminInput = {
  amount: Scalars['Float']['input']
  externalSubscriptionScheduleId?: InputMaybe<Scalars['String']['input']>
  frequency: GivingDonationFrequency
  startDate: Scalars['DateTime']['input']
}

export type UpdateSubscriptionPersonalDetailAdminInput = {
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  lastName: Scalars['String']['input']
}

export type UpdateSubscriptionResponse = {
  __typename?: 'UpdateSubscriptionResponse'
  clientSecret?: Maybe<Scalars['String']['output']>
  subscriptionId?: Maybe<Scalars['ID']['output']>
}

export type UpdateTemplateInput = {
  htmlLayout?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  layout?: InputMaybe<PageLayoutInput>
  name?: InputMaybe<Scalars['String']['input']>
  screenshotImageUrl?: InputMaybe<Scalars['String']['input']>
}

export type Video = Component & {
  __typename?: 'Video'
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  title?: Maybe<Scalars['String']['output']>
  type: ComponentType
  url?: Maybe<Scalars['String']['output']>
}

export type VideoInput = {
  componentId: Scalars['ID']['input']
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  position?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  styles?: InputMaybe<Scalars['JSON']['input']>
  text?: InputMaybe<TextInput>
  title?: InputMaybe<Scalars['String']['input']>
  type: ComponentTypeInput
  url?: InputMaybe<Scalars['String']['input']>
}

export type VirtualGiftSection = Component & {
  __typename?: 'VirtualGiftSection'
  id: Scalars['ID']['output']
  mobileStyles?: Maybe<Scalars['JSON']['output']>
  styles?: Maybe<Scalars['JSON']['output']>
  subComponents?: Maybe<Scalars['JSON']['output']>
  type: ComponentType
}

export type VirtualGiftSectionInput = {
  componentId: Scalars['ID']['input']
  mobileStyles?: InputMaybe<Scalars['JSON']['input']>
  styles?: InputMaybe<Scalars['JSON']['input']>
  subComponents: Scalars['JSON']['input']
  type: ComponentTypeInput
}
